<template>
    <div class="page__main container notifications-page js-notifications-page">
        <div class="page__index block block-index">
            <div class="personal-section notifications__section">
                <div class="notifications__welcome">
                    <h1>Настройки уведомлений</h1>
                    <div class="text-light">
                        Данные настройки применяются ко всем лицевых счетам
                    </div>
                </div>

                <div class="personal-section__item notifications__item">
                    <div id="personalSection_1" class="personal-section__drop accordion-body">
                        <div class="personal-section__inner accordion-body__inner">
                            <div class="settings">
                                <form action="">
                                    <!-- Настройки рассылки платежных документов: -->
                                    <!--<div class="settings__item head-card head-card--fill card">
        <div class="head-card__body">
            <div class="head-card__title h3">Настройки рассылки платежных документов:</div>
            <div class="head-card__caption">Подпишитесь на получение счетов, Lorem ipsum – псевдо-латинский текст, который используется для веб дизайна, типографии, оборудования, и распечатки вместо английского</div>
        </div>
        <div class="head-card__icon">
            <img src="/images/card-head-icons/docs.svg" alt="">
        </div>
    </div>-->
                                    <!-- Получение платежного документа -->
                                    <!--<div class="settings__item js-settings__item data-card block">
    <div class="data-card__head">
        <div class="data-card__subhead">
            <div class="data-card__title h3">Получение платежного документа</div>
        </div>
        <div class="data-card__right data-card__right--revere">
            <label class="js-notification-switch switch switch--right">
                <input class="switch__checkbox" data-toggle-switch="" data-target="#dataCard_11" type="checkbox">
                <div class="switch__label">
                    <div class="switch__text">Нет</div>
                    <div class="switch__text _last">Да</div>
                </div>
                <div class="switch__view"></div>
            </label>
        </div>
    </div>-->
                                    <!-- data-card__form data-card__form--sm -->
                                    <!--<div id="dataCard_11" class="notifications__card-form js-notifications__card-form  accordion-body collapse">
    <div class="data-card__caption">
        ЕПД — это единый платежный документ размером А4+ (228 на 450 миллиметров). Документ отправляют без конверта, но сложенным и запечатанным по краям.
    </div>
    <div class="data-card__inner accordion-body__inner">
        <div class="small-form">
            <div class="small-form__body">
                <div class="notifications__select-block js-notifications__select-block b-select">
                    <div class="btn-group bootstrap-select b-select__picker">-->
                                    <!--<button type="button" class="button dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button" title="Не выбрано"><span class="filter-option pull-left">Не выбрано</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span></button>
    <div class="dropdown-menu open" role="combobox">
        <ul class="dropdown-menu inner" role="listbox" aria-expanded="false">
            <li data-original-index="0" class="selected"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true"><span class="text">Не выбрано</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li>
            <li data-original-index="1">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5">
                                    <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                                    <g clip-path="url(#a)" stroke="#fff" stroke-width=".444">
                                        <rect x="4.111" y="3.222" width="5.778" height="7.556" rx=".667"></rect>
                                        <path d="M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z"></path>
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" transform="translate(3.889 3)" d="M0 0h6.222v8H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">SMS</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="2">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5">
                                    <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                                    <g clip-path="url(#a)">
                                        <path d="M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z" fill="#fff"></path>
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" transform="translate(2 2)" d="M0 0h10v10H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">E-mail</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="3">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5">
                                    <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                                    <g clip-path="url(#a)" stroke="#fff" stroke-width=".444">
                                        <rect x="4.111" y="3.222" width="5.778" height="7.556" rx=".667"></rect>
                                        <path d="M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z"></path>
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" transform="translate(3.889 3)" d="M0 0h6.222v8H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">Push-сообщение</div>
                            <span class="notifications-select__text-xs">В мобильном приложении</span>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li class="divider" data-original-index="4"></li>
            <li data-original-index="5">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5" clip-path="url(#a)">
                                    <path d="M9.855 4.183h.01c.097 0 .187.03.261.083l-.001-.001c.054.047.09.113.099.187v.001a1.186 1.186 0 0 1 .011.278v-.004c-.104 1.101-.558 3.772-.789 5.004-.097.522-.29.697-.475.714-.404.037-.71-.267-1.102-.524-.613-.402-.96-.652-1.554-1.044-.687-.452-.241-.702.15-1.108.103-.107 1.883-1.726 1.918-1.873a.143.143 0 0 0-.033-.123.158.158 0 0 0-.085-.025.17.17 0 0 0-.06.011h.001c-.061.013-1.04.66-2.936 1.94a1.304 1.304 0 0 1-.752.278h-.003A4.9 4.9 0 0 1 3.4 7.711l.035.01c-.436-.141-.783-.216-.753-.457.016-.125.188-.253.518-.384A324.895 324.895 0 0 1 7.258 5.13a10.517 10.517 0 0 1 2.523-.934l.074-.014ZM6.977-.007a7 7 0 1 0 .033 0h-.033Z" fill="#343A4A"></path>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" d="M0 0h14v14H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">Telegram</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="6">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5" clip-path="url(#a)">
                                    <path d="M11.301 9.988h-1.017c-.385 0-.504-.307-1.195-1.007-.603-.584-.87-.662-1.017-.662-.208 0-.267.06-.267.346v.918c0 .247-.079.395-.73.395a3.966 3.966 0 0 1-3.102-1.85l-.01-.017a8.148 8.148 0 0 1-1.6-3.333l-.011-.054c0-.148.06-.287.346-.287h1.017c.256 0 .355.119.455.395.503 1.452 1.343 2.726 1.689 2.726.128 0 .187-.06.187-.385V5.671c-.04-.692-.405-.75-.405-.997a.245.245 0 0 1 .257-.237h1.6c.217 0 .296.118.296.375v2.025c0 .217.1.296.158.296.129 0 .238-.079.475-.315.491-.601.912-1.288 1.233-2.029l.021-.056a.452.452 0 0 1 .42-.287l.026.001h-.001 1.017c.306 0 .375.158.306.376-.408.898-.866 1.67-1.397 2.385l.024-.035c-.108.178-.148.257 0 .455.108.148.464.454.701.73.343.34.63.735.848 1.17l.011.027c.1.285-.05.434-.336.434l.001-.001ZM9.15.002H4.852C.93.002.002.93.002 4.852v4.296c0 3.921.929 4.85 4.85 4.85h4.297c3.92 0 4.85-.928 4.85-4.85V4.851c0-3.92-.94-4.85-4.85-4.85Z" fill="#343A4A"></path>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" d="M0 0h14v14H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">ВКонтакте</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="7">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity=".5" clip-path="url(#a)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.998 0C3.139 0 0 3.14 0 7c0 1.53.494 2.95 1.333 4.103l-.872 2.6 2.69-.86A6.944 6.944 0 0 0 7.002 14C10.861 14 14 10.86 14 7s-3.139-7-6.998-7h-.004ZM5.044 3.556c-.136-.325-.239-.338-.444-.346a3.948 3.948 0 0 0-.235-.008c-.268 0-.547.078-.716.25-.206.21-.716.7-.716 1.704 0 1.005.733 1.976.831 2.112.103.135 1.428 2.226 3.485 3.078 1.608.666 2.086.605 2.452.527.535-.116 1.205-.51 1.374-.988.169-.478.169-.885.12-.971-.05-.087-.186-.136-.392-.24-.205-.102-1.205-.596-1.394-.662-.185-.07-.362-.045-.502.153-.198.275-.39.555-.547.724-.124.132-.325.148-.494.078-.226-.094-.86-.317-1.642-1.012-.604-.54-1.016-1.21-1.135-1.412-.12-.205-.012-.325.082-.436.103-.127.202-.218.305-.337.103-.12.16-.181.226-.321.07-.136.02-.276-.029-.379-.05-.103-.46-1.107-.63-1.514Z" fill="#343A4A"></path>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" d="M0 0h14v14H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">WhatsApp</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
        </ul>
    </div>-->
                                    <!--<select class="b-select__picker selectpicker" data-style-base="button" tabindex="-98">
                <option value="">Не выбрано</option>
                <option value="push" data-select="phone" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                <div class=&quot;notifications-select__left&quot;>
                                    <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                        <g opacity=&quot;.5&quot;>
                                            <rect width=&quot;14&quot; height=&quot;14&quot; rx=&quot;7&quot; fill=&quot;#343A4A&quot;/>
                                            <g clip-path=&quot;url(#a)&quot; stroke=&quot;#fff&quot; stroke-width=&quot;.444&quot;>
                                                <rect x=&quot;4.111&quot; y=&quot;3.222&quot; width=&quot;5.778&quot; height=&quot;7.556&quot; rx=&quot;.667&quot;/>
                                                <path d=&quot;M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z&quot;/>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id=&quot;a&quot;>
                                                <path fill=&quot;#fff&quot; transform=&quot;translate(3.889 3)&quot; d=&quot;M0 0h6.222v8H0z&quot;/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class=&quot;notifications-select__right&quot;>
                                    <div class=&quot;notifications-select__text-m&quot;>SMS</div>
                                </div>
                            </div>">
                </option>
                <option value="push" data-select="email" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                            <g opacity=&quot;.5&quot;>
                                                <rect width=&quot;14&quot; height=&quot;14&quot; rx=&quot;7&quot; fill=&quot;#343A4A&quot;/>
                                                <g clip-path=&quot;url(#a)&quot;>
                                                    <path d=&quot;M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z&quot; fill=&quot;#fff&quot;/>
                                                </g>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; transform=&quot;translate(2 2)&quot; d=&quot;M0 0h10v10H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>E-mail</div>
                                    </div>
                                </div>">
        </option>
                <option value="push" data-content="<div class='notifications-select__wrapper'>
                                <div class='notifications-select__left'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none'>
                                        <g opacity='.5'>
                                            <rect width='14' height='14' rx='7' fill='#343A4A'/>
                                            <g clip-path='url(#a)' stroke='#fff' stroke-width='.444'>
                                                <rect x='4.111' y='3.222' width='5.778' height='7.556' rx='.667'/>
                                                <path d='M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z'/>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id='a'>
                                                <path fill='#fff' transform='translate(3.889 3)' d='M0 0h6.222v8H0z'/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class='notifications-select__right'>
                                    <div class='notifications-select__text-m'>Push-сообщение</div>
                                    <span class='notifications-select__text-xs'>В мобильном приложении</span>
                                </div>
                            </div>">
        </option>
                <option data-divider="true"></option>
                <option value="telegram" data-select="telegram" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                            <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                <path d=&quot;M9.855 4.183h.01c.097 0 .187.03.261.083l-.001-.001c.054.047.09.113.099.187v.001a1.186 1.186 0 0 1 .011.278v-.004c-.104 1.101-.558 3.772-.789 5.004-.097.522-.29.697-.475.714-.404.037-.71-.267-1.102-.524-.613-.402-.96-.652-1.554-1.044-.687-.452-.241-.702.15-1.108.103-.107 1.883-1.726 1.918-1.873a.143.143 0 0 0-.033-.123.158.158 0 0 0-.085-.025.17.17 0 0 0-.06.011h.001c-.061.013-1.04.66-2.936 1.94a1.304 1.304 0 0 1-.752.278h-.003A4.9 4.9 0 0 1 3.4 7.711l.035.01c-.436-.141-.783-.216-.753-.457.016-.125.188-.253.518-.384A324.895 324.895 0 0 1 7.258 5.13a10.517 10.517 0 0 1 2.523-.934l.074-.014ZM6.977-.007a7 7 0 1 0 .033 0h-.033Z&quot; fill=&quot;#343A4A&quot;/>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>Telegram</div>
                                    </div>
                                </div>">
        </option>
                <option value="vk" data-select="vk" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                            <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                <path d=&quot;M11.301 9.988h-1.017c-.385 0-.504-.307-1.195-1.007-.603-.584-.87-.662-1.017-.662-.208 0-.267.06-.267.346v.918c0 .247-.079.395-.73.395a3.966 3.966 0 0 1-3.102-1.85l-.01-.017a8.148 8.148 0 0 1-1.6-3.333l-.011-.054c0-.148.06-.287.346-.287h1.017c.256 0 .355.119.455.395.503 1.452 1.343 2.726 1.689 2.726.128 0 .187-.06.187-.385V5.671c-.04-.692-.405-.75-.405-.997a.245.245 0 0 1 .257-.237h1.6c.217 0 .296.118.296.375v2.025c0 .217.1.296.158.296.129 0 .238-.079.475-.315.491-.601.912-1.288 1.233-2.029l.021-.056a.452.452 0 0 1 .42-.287l.026.001h-.001 1.017c.306 0 .375.158.306.376-.408.898-.866 1.67-1.397 2.385l.024-.035c-.108.178-.148.257 0 .455.108.148.464.454.701.73.343.34.63.735.848 1.17l.011.027c.1.285-.05.434-.336.434l.001-.001ZM9.15.002H4.852C.93.002.002.93.002 4.852v4.296c0 3.921.929 4.85 4.85 4.85h4.297c3.92 0 4.85-.928 4.85-4.85V4.851c0-3.92-.94-4.85-4.85-4.85Z&quot; fill=&quot;#343A4A&quot;/>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>ВКонтакте</div>
                                    </div>
                                </div>">
        </option>
                <option value="whatsapp" data-select="whatsapp" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;>
                                            <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                <path fill-rule=&quot;evenodd&quot; clip-rule=&quot;evenodd&quot; d=&quot;M6.998 0C3.139 0 0 3.14 0 7c0 1.53.494 2.95 1.333 4.103l-.872 2.6 2.69-.86A6.944 6.944 0 0 0 7.002 14C10.861 14 14 10.86 14 7s-3.139-7-6.998-7h-.004ZM5.044 3.556c-.136-.325-.239-.338-.444-.346a3.948 3.948 0 0 0-.235-.008c-.268 0-.547.078-.716.25-.206.21-.716.7-.716 1.704 0 1.005.733 1.976.831 2.112.103.135 1.428 2.226 3.485 3.078 1.608.666 2.086.605 2.452.527.535-.116 1.205-.51 1.374-.988.169-.478.169-.885.12-.971-.05-.087-.186-.136-.392-.24-.205-.102-1.205-.596-1.394-.662-.185-.07-.362-.045-.502.153-.198.275-.39.555-.547.724-.124.132-.325.148-.494.078-.226-.094-.86-.317-1.642-1.012-.604-.54-1.016-1.21-1.135-1.412-.12-.205-.012-.325.082-.436.103-.127.202-.218.305-.337.103-.12.16-.181.226-.321.07-.136.02-.276-.029-.379-.05-.103-.46-1.107-.63-1.514Z&quot; fill=&quot;#343A4A&quot;/>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>WhatsApp</div>
                                    </div>
                                </div>">
        </option>
            </select>
        </div>
    </div>
    <div class="notifications-add__input-block declarer-add__input-block declarer-add__input-block--medium declarer-add__input-block--notebook-half js-sub-block-form js-capcha-container js-code-container js-form js-valid-input-container js-timer-container">
        <div class="js-notifications-input-block is-disabled notifications-input-block declarer-add__input declarer-add__input--relative">
            <input class="js-notifications-input-phone notifications-input-phone txt-input__field input req js-base-input" type="text" value="+7 913-111-1111" data-mask-phone="">
            <input class="js-notifications-input-email notifications-input-email txt-input__field input req js-valid-email js-valid-input is-hidden" value="petrov@ya.ru" type="text" placeholder="E-mail" data-type="email" required="">
            <div class="notifications__status-wrapper js-notifications__status-wrapper status--error">
                <a href="#dataCard_main_phone" class="js-notifications-confirm-btn notifications-confirm-btn link link--present declarer-add__input-confirm-btn js-input-confirm-btn" data-toggle="collapse">
                    <span class="link__text">Подтвердить</span>
                </a>
                <button type="button" class="js-notifications-confirm-btn-sucsess notifications-confirm-btn-sucsess is-hidden" data-toggle="collapse" data-target="#dataCard_info-block-text_1">
                    <span class="link__text">Подключить</span>
                </button>
                <a href="" class="button notifications-loader js-form-payment is-overlay is-hidden"></a>
                <div class="notifications-status__secsessed js-notifications-status__secsessed is-hidden status--success">Подключено</div>
            </div>
        </div>
        <div class="notifications-accordion-body js-notifications-accordion-body is-hidden">
            <div class="accordion-body__inner register-form__row">-->
                                    <!-- капча -->
                                    <!--<div class="register-form__row js-capcha-show-container">
        <div class="data-card__form-button data-card__form-button--grow txt-input__input">
            <input type="text" class="txt-input__field input req js-capcha-input" placeholder="Введите капчу">
            <div class="txt-input__required txt-input__required--error txt-input__required--dbl">Текст ошибки для поля</div>
        </div>
        <div class="data-card__form-button data-card__form-button--grow capcha-image js-capcha-image">
            <img src="/images/capcha.png" alt="">
            <div class="data-card__form-button" style="display: none;">
                <button type="button" class="button button--th-main js-poison-code">Отправить снова</button>
            </div>
        </div>
        <button type="button" class="data-card__form-button data-card__form-button--lg button button--th-main js-capcha-next-trigger" style="display: none;">OK</button>
    </div>-->
                                    <!-- кнопка для отправки кода -->
                                    <!--<a href="#dataCard_main_phone" class="js-notifications-item-hidden-block js-notifications-item-hidden-block data-card__form-button data-card__form-button--grow button button--th-second js-capcha-hidden-block-entering js-precaptcha-cancel-btn" data-toggle-switch="" data-target="#dataCard_11" data-toggle="collapse" style="display: none;">Отменить</a>
    <button data-toggle="collapse" data-target="#dataCard_info-block-phone_1" type="button" class="data-card__form-button data-card__form-button--grow button button--th-main js-poison-code js-capcha-show-hidden-blocks js-capcha-hidden-block js-precaptcha-hide-cancel-btn js-notifications-capcha-timer" style="display: none;">
        Отправить<br>код
    </button>-->
                                    <!-- код -->
                                    <!--<div class="register-form__row js-connect-edm js-code-inner" style="display: none;">
                                        <label class="txt-input data-card__form-button data-card__form-button--grow">
                                            <input class="input js-code-input" type="text" placeholder="код">
                                            <div class="txt-input__required txt-input__required--success txt-input__required--dbl">Код введен верно</div>
                                            <div class="txt-input__required txt-input__required--error txt-input__required--dbl">Код введен неверно</div>
                                        </label>
                                        <div class="data-card__form-button data-card__form-button--grow data-card__form-button--flex timer-container-sm">
                                            <button data-toggle="collapse" data-target="#dataCard_info-block-phone_1" type="button" class="js-notifications-code-sumbit data-card__form-button data-card__form-button--grow button button--th-main timer-container-sm__btn js-code-submit js-make-input-readonly">
                                                OK
                                                <span class="form-timer form-timer--light js-timer">
                                                    <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                        <path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
                                                                M 50, 50
                                                                m -45, 0
                                                                a 45,45 0 1,0 90,0
                                                                a 45,45 0 1,0 -90,0
                                                                "></path>
                                                    </svg>
                                                    <span class="js-timer-count form-timer__count">
                                                    </span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <button type="button" class="data-card__form-button button button--th-main js-poison-code js-poison-code-again" style="display: none;">Отправить<br>еще раз</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="dataCard_info-block-phone_1" class="notifications-info-block accordion-body collapse">
                        <div class="info-block-with-icon">
                            <div class="info-block-with-icon__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                </svg>
                            </div>
                            <div class="js-info-block-with-icon__text info-block-with-icon__text">
                                Введите код, который мы отправим на номер +7 (961)-701-0000
                            </div>
                        </div>
                    </div>
                    <div id="dataCard_info-block-text_1" class="notifications-info-block accordion-body collapse">
                        <div class="info-block-with-icon">
                            <div class="info-block-with-icon__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                </svg>
                            </div>
                            <div class="info-block-with-icon__text">
                                Указанные изменения вступят в силу с 1 числа нового расчётного месяца
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
                                    <!-- Рассылка Электронного платёжного документа на E-mail -->
                                    <!--<div class="settings__item js-settings__item data-card block is-successed">
    <div class="data-card__head">
        <div class="data-card__subhead">
            <div class="data-card__title h3">Рассылка Электронного платёжного документа на E-mail</div>
        </div>
        <div class="data-card__right data-card__right--revere">
            <label class="js-notification-switch switch switch--right">
                <input class="switch__checkbox" data-toggle-switch="" data-target="#dataCard_12" type="checkbox">
                <div class="switch__label">
                    <div class="switch__text">Нет</div>
                    <div class="switch__text _last">Да</div>
                </div>
                <div class="switch__view"></div>
            </label>
        </div>
    </div>
    <div id="dataCard_12" class="notifications__card-form js-notifications__card-form  accordion-body collapse">
        <div class="data-card__caption">
            Введите E-mail, чтобы получать рассылку по электронной почте
        </div>
        <div class="data-card__inner accordion-body__inner">
            <div class="small-form">
                <div class="small-form__body">
                    <div class="notifications__select-block js-notifications__select-block b-select">
                        <div class="btn-group bootstrap-select b-select__picker">-->
                                    <!--<button type="button" class="button dropdown-toggle btn-default" data-toggle="dropdown" role="button" title="E-mail">
        <span class="filter-option pull-left">
            <div class="notifications-select__wrapper">
                <div class="notifications-select__left">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                        <g opacity=".5">
                            <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                            <g clip-path="url(#a)">
                                <path d="M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z" fill="#fff"></path>
                            </g>
                        </g>
                        <defs>
                            <clipPath id="a">
                                <path fill="#fff" transform="translate(2 2)" d="M0 0h10v10H0z"></path>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="notifications-select__right">
                    <div class="notifications-select__text-m">E-mail</div>
                </div>
            </div>
        </span>&nbsp;<span class="bs-caret"><span class="caret"></span></span>
    </button>
    <div class="dropdown-menu open" role="combobox">
        <ul class="dropdown-menu inner" role="listbox" aria-expanded="false">
            <li data-original-index="0" class="selected">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5">
                                    <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                                    <g clip-path="url(#a)">
                                        <path d="M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z" fill="#fff"></path>
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" transform="translate(2 2)" d="M0 0h10v10H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">E-mail</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li class="divider" data-original-index="1"></li>
        </ul>
    </div>-->
                                    <!--<select class="b-select__picker selectpicker" data-style-base="button" tabindex="-98">-->
                                    <!-- <option value="">Не выбрано</option> -->
                                    <!-- <option value="" data-selcet="phone">SMS</option> -->
                                    <!--<option value="push" data-select="email" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                <div class=&quot;notifications-select__left&quot;>
                                    <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                        <g opacity=&quot;.5&quot;>
                                            <rect width=&quot;14&quot; height=&quot;14&quot; rx=&quot;7&quot; fill=&quot;#343A4A&quot;/>
                                            <g clip-path=&quot;url(#a)&quot;>
                                                <path d=&quot;M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z&quot; fill=&quot;#fff&quot;/>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id=&quot;a&quot;>
                                                <path fill=&quot;#fff&quot; transform=&quot;translate(2 2)&quot; d=&quot;M0 0h10v10H0z&quot;/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class=&quot;notifications-select__right&quot;>
                                    <div class=&quot;notifications-select__text-m&quot;>E-mail</div>
                                </div>
                            </div>">
    </option>-->
                                    <!-- <option value="">
        Push-сообщение
        <br/> В мобильном приложении
    </option> -->
                                    <!--<option data-divider="true"></option>-->
                                    <!-- <option value="">Telegram</option>
    <option value="">ВКонтакте</option>
    <option value="">WhatsApp</option>
    <option data-divider="true"></option> -->
                                    <!--</select>
        </div>
    </div>
    <div class="notifications-add__input-block declarer-add__input-block declarer-add__input-block--medium declarer-add__input-block--notebook-half js-sub-block-form js-capcha-container js-code-container js-form js-valid-input-container js-timer-container">
        <div class="js-notifications-input-block notifications-input-block declarer-add__input declarer-add__input--relative">
            <input class="js-notifications-input-phone notifications-input-phone txt-input__field input req js-base-input is-hidden" type="text" value="+7 913-111-1111" data-mask-phone="">
            <input class="js-notifications-input-email notifications-input-email txt-input__field input req js-valid-input" value="petrov@ya.ru" readonly="" type="text" placeholder="E-mail" data-type="email">
            <div class="notifications__status-wrapper status--success">
                <a href="#dataCard_main_phone-2" class="js-notifications-confirm-btn notifications-confirm-btn link link--present declarer-add__input-confirm-btn js-input-confirm-btn" data-toggle="collapse">
                    <span class="link__text">Подтвердить</span>
                </a>
                <button type="button" class="js-notifications-confirm-btn-sucsess notifications-confirm-btn-sucsess is-hidden" data-toggle="collapse" data-target="#dataCard_info-block-text_2">
                    <span class="link__text">Подключить</span>
                </button>
                <a href="" class="button notifications-loader js-form-payment is-overlay is-hidden"></a>
                <div class="notifications-status__secsessed js-notifications-status__secsessed is-hidden status--success">Подключено</div>
            </div>
        </div>
        <div class="notifications-accordion-body js-notifications-accordion-body is-hidden">
            <div class="accordion-body__inner register-form__row">-->
                                    <!-- капча -->
                                    <!--<div class="register-form__row js-capcha-show-container">
        <div class="data-card__form-button data-card__form-button--grow txt-input__input">
            <input type="text" class="txt-input__field input req js-capcha-input" placeholder="Введите капчу">
            <div class="txt-input__required txt-input__required--error txt-input__required--dbl">Текст ошибки для поля</div>
        </div>
        <div class="data-card__form-button data-card__form-button--grow capcha-image js-capcha-image">
            <img src="/images/capcha.png" alt="">
            <div class="data-card__form-button" style="display: none;">
                <button type="button" class="button button--th-main js-poison-code">Отправить снова</button>
            </div>
        </div>
        <button type="button" class="data-card__form-button data-card__form-button--lg button button--th-main js-capcha-next-trigger" style="display: none;">OK</button>
    </div>-->
                                    <!-- кнопка для отправки кода -->
                                    <!--<a href="#dataCard_main_phone" class="js-notifications-item-hidden-block data-card__form-button data-card__form-button--grow button button--th-second js-capcha-hidden-block-entering js-precaptcha-cancel-btn" data-toggle="collapse" style="display: none;">Отменить</a>
    <button data-toggle="collapse" data-target="#dataCard_info-block-phone_2" type="button" class="data-card__form-button data-card__form-button--grow button button--th-main js-poison-code js-capcha-show-hidden-blocks js-capcha-hidden-block js-precaptcha-hide-cancel-btn js-notifications-capcha-timer" style="display: none;">
        Отправить<br>код
    </button>-->
                                    <!-- код -->
                                    <!--<div class="register-form__row js-connect-edm js-code-inner" style="display: none;">
                                        <label class="txt-input data-card__form-button data-card__form-button--grow">
                                            <input class="input js-code-input" type="text" placeholder="код">
                                            <div class="txt-input__required txt-input__required--success txt-input__required--dbl">Код введен верно</div>
                                            <div class="txt-input__required txt-input__required--error txt-input__required--dbl">Код введен неверно</div>
                                        </label>
                                        <div class="data-card__form-button data-card__form-button--grow data-card__form-button--flex timer-container-sm">
                                            <button data-toggle="collapse" data-target="#dataCard_info-block-phone_2" type="button" class="js-notifications-code-sumbit data-card__form-button data-card__form-button--grow button button--th-main timer-container-sm__btn js-code-submit js-make-input-readonly">
                                                OK
                                                <span class="form-timer form-timer--light js-timer">
                                                    <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                        <path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
                                                                M 50, 50
                                                                m -45, 0
                                                                a 45,45 0 1,0 90,0
                                                                a 45,45 0 1,0 -90,0
                                                                "></path>
                                                    </svg>
                                                    <span class="js-timer-count form-timer__count">
                                                    </span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <button type="button" class="data-card__form-button button button--th-main js-poison-code js-poison-code-again" style="display: none;">Отправить<br>еще раз</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="dataCard_info-block-phone_2" class="notifications-info-block accordion-body collapse">
                        <div class="info-block-with-icon">
                            <div class="info-block-with-icon__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                </svg>
                            </div>
                            <div class="js-info-block-with-icon__text info-block-with-icon__text">
                                Введите код, который мы отправим на номер +7 (961)-701-0000
                            </div>
                        </div>
                    </div>
                    <div id="dataCard_info-block-text_2" class="notifications-info-block accordion-body collapse">
                        <div class="info-block-with-icon">
                            <div class="info-block-with-icon__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                </svg>
                            </div>
                            <div class="info-block-with-icon__text">
                                Указанные изменения вступят в силу с 1 числа нового расчётного месяца
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="settings__item js-settings__item data-card data-card--end block">
        <div class="data-card__head">
            <div class="data-card__subhead">
                <div class="data-card__title h3">Отказаться от бумажной версии ЕПД</div>

            </div>
            <div class="data-card__right data-card__right--revere">
                <label class="js-notification-switch switch switch--right">
                    <input class="switch__checkbox" data-toggle-switch="" data-target="#dataCard_20" type="checkbox">
                    <div class="switch__label">
                        <div class="switch__text">Нет</div>
                        <div class="switch__text _last">Да</div>
                    </div>
                    <div class="switch__view"></div>
                </label>
            </div>
        </div>-->
                                    <!-- data-card__form data-card__form--sm -->
                                    <!--<div id="dataCard_20" class="notifications__card-form js-notifications__card-form  accordion-body collapse">
    <div class="data-card__caption">
        Вы не будете получать бумажную версию платёжного документа в Ваш почтовый ящик и поможете спасти дерево. Вы всегда можете скачать ЕПД на нашем портале и в мобильном приложении, а бумажную версию получить в наших ЦОК. Спасибо.
    </div>
    <div class="data-card__inner accordion-body__inner">
        <div class="small-form">
            <div class="small-form__body">
                <div class="notifications__select-block js-notifications__select-block b-select">
                    <div class="btn-group bootstrap-select b-select__picker">-->
                                    <!--<button type="button" class="button dropdown-toggle bs-placeholder btn-default" data-toggle="dropdown" role="button" title="Не выбрано"><span class="filter-option pull-left">Не выбрано</span>&nbsp;<span class="bs-caret"><span class="caret"></span></span></button>
    <div class="dropdown-menu open" role="combobox">
        <ul class="dropdown-menu inner" role="listbox" aria-expanded="false">
            <li data-original-index="0" class="selected"><a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="true"><span class="text">Не выбрано</span><span class="glyphicon glyphicon-ok check-mark"></span></a></li>
            <li data-original-index="1">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5">
                                    <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                                    <g clip-path="url(#a)" stroke="#fff" stroke-width=".444">
                                        <rect x="4.111" y="3.222" width="5.778" height="7.556" rx=".667"></rect>
                                        <path d="M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z"></path>
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" transform="translate(3.889 3)" d="M0 0h6.222v8H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">SMS</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="2">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5">
                                    <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                                    <g clip-path="url(#a)">
                                        <path d="M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z" fill="#fff"></path>
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" transform="translate(2 2)" d="M0 0h10v10H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">E-mail</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="3">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5">
                                    <rect width="14" height="14" rx="7" fill="#343A4A"></rect>
                                    <g clip-path="url(#a)" stroke="#fff" stroke-width=".444">
                                        <rect x="4.111" y="3.222" width="5.778" height="7.556" rx=".667"></rect>
                                        <path d="M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z"></path>
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" transform="translate(3.889 3)" d="M0 0h6.222v8H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">Push-сообщение</div>
                            <span class="notifications-select__text-xs">В мобильном приложении</span>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li class="divider" data-original-index="4"></li>
            <li data-original-index="5">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5" clip-path="url(#a)">
                                    <path d="M9.855 4.183h.01c.097 0 .187.03.261.083l-.001-.001c.054.047.09.113.099.187v.001a1.186 1.186 0 0 1 .011.278v-.004c-.104 1.101-.558 3.772-.789 5.004-.097.522-.29.697-.475.714-.404.037-.71-.267-1.102-.524-.613-.402-.96-.652-1.554-1.044-.687-.452-.241-.702.15-1.108.103-.107 1.883-1.726 1.918-1.873a.143.143 0 0 0-.033-.123.158.158 0 0 0-.085-.025.17.17 0 0 0-.06.011h.001c-.061.013-1.04.66-2.936 1.94a1.304 1.304 0 0 1-.752.278h-.003A4.9 4.9 0 0 1 3.4 7.711l.035.01c-.436-.141-.783-.216-.753-.457.016-.125.188-.253.518-.384A324.895 324.895 0 0 1 7.258 5.13a10.517 10.517 0 0 1 2.523-.934l.074-.014ZM6.977-.007a7 7 0 1 0 .033 0h-.033Z" fill="#343A4A"></path>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" d="M0 0h14v14H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">Telegram</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="6">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none">
                                <g opacity=".5" clip-path="url(#a)">
                                    <path d="M11.301 9.988h-1.017c-.385 0-.504-.307-1.195-1.007-.603-.584-.87-.662-1.017-.662-.208 0-.267.06-.267.346v.918c0 .247-.079.395-.73.395a3.966 3.966 0 0 1-3.102-1.85l-.01-.017a8.148 8.148 0 0 1-1.6-3.333l-.011-.054c0-.148.06-.287.346-.287h1.017c.256 0 .355.119.455.395.503 1.452 1.343 2.726 1.689 2.726.128 0 .187-.06.187-.385V5.671c-.04-.692-.405-.75-.405-.997a.245.245 0 0 1 .257-.237h1.6c.217 0 .296.118.296.375v2.025c0 .217.1.296.158.296.129 0 .238-.079.475-.315.491-.601.912-1.288 1.233-2.029l.021-.056a.452.452 0 0 1 .42-.287l.026.001h-.001 1.017c.306 0 .375.158.306.376-.408.898-.866 1.67-1.397 2.385l.024-.035c-.108.178-.148.257 0 .455.108.148.464.454.701.73.343.34.63.735.848 1.17l.011.027c.1.285-.05.434-.336.434l.001-.001ZM9.15.002H4.852C.93.002.002.93.002 4.852v4.296c0 3.921.929 4.85 4.85 4.85h4.297c3.92 0 4.85-.928 4.85-4.85V4.851c0-3.92-.94-4.85-4.85-4.85Z" fill="#343A4A"></path>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" d="M0 0h14v14H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">ВКонтакте</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
            <li data-original-index="7">
                <a tabindex="0" class="" data-tokens="null" role="option" aria-disabled="false" aria-selected="false">
                    <div class="notifications-select__wrapper">
                        <div class="notifications-select__left">
                            <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g opacity=".5" clip-path="url(#a)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.998 0C3.139 0 0 3.14 0 7c0 1.53.494 2.95 1.333 4.103l-.872 2.6 2.69-.86A6.944 6.944 0 0 0 7.002 14C10.861 14 14 10.86 14 7s-3.139-7-6.998-7h-.004ZM5.044 3.556c-.136-.325-.239-.338-.444-.346a3.948 3.948 0 0 0-.235-.008c-.268 0-.547.078-.716.25-.206.21-.716.7-.716 1.704 0 1.005.733 1.976.831 2.112.103.135 1.428 2.226 3.485 3.078 1.608.666 2.086.605 2.452.527.535-.116 1.205-.51 1.374-.988.169-.478.169-.885.12-.971-.05-.087-.186-.136-.392-.24-.205-.102-1.205-.596-1.394-.662-.185-.07-.362-.045-.502.153-.198.275-.39.555-.547.724-.124.132-.325.148-.494.078-.226-.094-.86-.317-1.642-1.012-.604-.54-1.016-1.21-1.135-1.412-.12-.205-.012-.325.082-.436.103-.127.202-.218.305-.337.103-.12.16-.181.226-.321.07-.136.02-.276-.029-.379-.05-.103-.46-1.107-.63-1.514Z" fill="#343A4A"></path>
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path fill="#fff" d="M0 0h14v14H0z"></path>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div class="notifications-select__right">
                            <div class="notifications-select__text-m">WhatsApp</div>
                        </div>
                    </div><span class="glyphicon glyphicon-ok check-mark"></span>
                </a>
            </li>
        </ul>
    </div>-->
                                    <!--<select class="b-select__picker selectpicker" data-style-base="button" tabindex="-98">
                <option value="">Не выбрано</option>
                <option value="push" data-select="phone" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                <div class=&quot;notifications-select__left&quot;>
                                    <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                        <g opacity=&quot;.5&quot;>
                                            <rect width=&quot;14&quot; height=&quot;14&quot; rx=&quot;7&quot; fill=&quot;#343A4A&quot;/>
                                            <g clip-path=&quot;url(#a)&quot; stroke=&quot;#fff&quot; stroke-width=&quot;.444&quot;>
                                                <rect x=&quot;4.111&quot; y=&quot;3.222&quot; width=&quot;5.778&quot; height=&quot;7.556&quot; rx=&quot;.667&quot;/>
                                                <path d=&quot;M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z&quot;/>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id=&quot;a&quot;>
                                                <path fill=&quot;#fff&quot; transform=&quot;translate(3.889 3)&quot; d=&quot;M0 0h6.222v8H0z&quot;/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class=&quot;notifications-select__right&quot;>
                                    <div class=&quot;notifications-select__text-m&quot;>SMS</div>
                                </div>
                            </div>">
        </option>
                <option value="push" data-select="email" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                            <g opacity=&quot;.5&quot;>
                                                <rect width=&quot;14&quot; height=&quot;14&quot; rx=&quot;7&quot; fill=&quot;#343A4A&quot;/>
                                                <g clip-path=&quot;url(#a)&quot;>
                                                    <path d=&quot;M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z&quot; fill=&quot;#fff&quot;/>
                                                </g>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; transform=&quot;translate(2 2)&quot; d=&quot;M0 0h10v10H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>E-mail</div>
                                    </div>
                                </div>">
        </option>
                <option value="push" data-content="<div class='notifications-select__wrapper'>
                                <div class='notifications-select__left'>
                                    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none'>
                                        <g opacity='.5'>
                                            <rect width='14' height='14' rx='7' fill='#343A4A'/>
                                            <g clip-path='url(#a)' stroke='#fff' stroke-width='.444'>
                                                <rect x='4.111' y='3.222' width='5.778' height='7.556' rx='.667'/>
                                                <path d='M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z'/>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id='a'>
                                                <path fill='#fff' transform='translate(3.889 3)' d='M0 0h6.222v8H0z'/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class='notifications-select__right'>
                                    <div class='notifications-select__text-m'>Push-сообщение</div>
                                    <span class='notifications-select__text-xs'>В мобильном приложении</span>
                                </div>
                            </div>">
        </option>
                <option data-divider="true"></option>
                <option value="telegram" data-select="telegram" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                            <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                <path d=&quot;M9.855 4.183h.01c.097 0 .187.03.261.083l-.001-.001c.054.047.09.113.099.187v.001a1.186 1.186 0 0 1 .011.278v-.004c-.104 1.101-.558 3.772-.789 5.004-.097.522-.29.697-.475.714-.404.037-.71-.267-1.102-.524-.613-.402-.96-.652-1.554-1.044-.687-.452-.241-.702.15-1.108.103-.107 1.883-1.726 1.918-1.873a.143.143 0 0 0-.033-.123.158.158 0 0 0-.085-.025.17.17 0 0 0-.06.011h.001c-.061.013-1.04.66-2.936 1.94a1.304 1.304 0 0 1-.752.278h-.003A4.9 4.9 0 0 1 3.4 7.711l.035.01c-.436-.141-.783-.216-.753-.457.016-.125.188-.253.518-.384A324.895 324.895 0 0 1 7.258 5.13a10.517 10.517 0 0 1 2.523-.934l.074-.014ZM6.977-.007a7 7 0 1 0 .033 0h-.033Z&quot; fill=&quot;#343A4A&quot;/>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>Telegram</div>
                                    </div>
                                </div>">
        </option>
                <option value="vk" data-select="vk" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                            <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                <path d=&quot;M11.301 9.988h-1.017c-.385 0-.504-.307-1.195-1.007-.603-.584-.87-.662-1.017-.662-.208 0-.267.06-.267.346v.918c0 .247-.079.395-.73.395a3.966 3.966 0 0 1-3.102-1.85l-.01-.017a8.148 8.148 0 0 1-1.6-3.333l-.011-.054c0-.148.06-.287.346-.287h1.017c.256 0 .355.119.455.395.503 1.452 1.343 2.726 1.689 2.726.128 0 .187-.06.187-.385V5.671c-.04-.692-.405-.75-.405-.997a.245.245 0 0 1 .257-.237h1.6c.217 0 .296.118.296.375v2.025c0 .217.1.296.158.296.129 0 .238-.079.475-.315.491-.601.912-1.288 1.233-2.029l.021-.056a.452.452 0 0 1 .42-.287l.026.001h-.001 1.017c.306 0 .375.158.306.376-.408.898-.866 1.67-1.397 2.385l.024-.035c-.108.178-.148.257 0 .455.108.148.464.454.701.73.343.34.63.735.848 1.17l.011.027c.1.285-.05.434-.336.434l.001-.001ZM9.15.002H4.852C.93.002.002.93.002 4.852v4.296c0 3.921.929 4.85 4.85 4.85h4.297c3.92 0 4.85-.928 4.85-4.85V4.851c0-3.92-.94-4.85-4.85-4.85Z&quot; fill=&quot;#343A4A&quot;/>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>ВКонтакте</div>
                                    </div>
                                </div>">
        </option>
                <option value="whatsapp" data-select="whatsapp" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                    <div class=&quot;notifications-select__left&quot;>
                                        <svg width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;>
                                            <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                <path fill-rule=&quot;evenodd&quot; clip-rule=&quot;evenodd&quot; d=&quot;M6.998 0C3.139 0 0 3.14 0 7c0 1.53.494 2.95 1.333 4.103l-.872 2.6 2.69-.86A6.944 6.944 0 0 0 7.002 14C10.861 14 14 10.86 14 7s-3.139-7-6.998-7h-.004ZM5.044 3.556c-.136-.325-.239-.338-.444-.346a3.948 3.948 0 0 0-.235-.008c-.268 0-.547.078-.716.25-.206.21-.716.7-.716 1.704 0 1.005.733 1.976.831 2.112.103.135 1.428 2.226 3.485 3.078 1.608.666 2.086.605 2.452.527.535-.116 1.205-.51 1.374-.988.169-.478.169-.885.12-.971-.05-.087-.186-.136-.392-.24-.205-.102-1.205-.596-1.394-.662-.185-.07-.362-.045-.502.153-.198.275-.39.555-.547.724-.124.132-.325.148-.494.078-.226-.094-.86-.317-1.642-1.012-.604-.54-1.016-1.21-1.135-1.412-.12-.205-.012-.325.082-.436.103-.127.202-.218.305-.337.103-.12.16-.181.226-.321.07-.136.02-.276-.029-.379-.05-.103-.46-1.107-.63-1.514Z&quot; fill=&quot;#343A4A&quot;/>
                                            </g>
                                            <defs>
                                                <clipPath id=&quot;a&quot;>
                                                    <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class=&quot;notifications-select__right&quot;>
                                        <div class=&quot;notifications-select__text-m&quot;>WhatsApp</div>
                                    </div>
                                </div>">
        </option>
            </select>
        </div>
    </div>
    <div class="notifications-add__input-block declarer-add__input-block declarer-add__input-block--medium declarer-add__input-block--notebook-half js-sub-block-form js-capcha-container js-code-container js-form js-valid-input-container js-timer-container">
        <div class="js-notifications-input-block is-disabled notifications-input-block declarer-add__input declarer-add__input--relative">
            <input class="js-notifications-input-phone notifications-input-phone txt-input__field input req js-base-input is-hidden" type="text" value="+7 913-111-1111" data-mask-phone="">
            <input class="js-notifications-input-email notifications-input-email txt-input__field input req js-valid-input" value="petrov@ya.ru" type="text" placeholder="E-mail" data-type="email">
            <div class="notifications__status-wrapper status--error">
                <a href="#dataCard_main_phone-20" class="js-notifications-confirm-btn notifications-confirm-btn link link--present declarer-add__input-confirm-btn js-input-confirm-btn" data-toggle="collapse">
                    <span class="link__text">Подтвердить</span>
                </a>
                <button type="button" class="js-notifications-confirm-btn-sucsess notifications-confirm-btn-sucsess is-hidden" data-toggle="collapse" data-target="#dataCard_info-block-text_20, #dataCard_info-block-text_20-1">
                    <span class="link__text">Подключить</span>
                </button>
                <a href="" class="button notifications-loader js-form-payment is-overlay is-hidden"></a>
                <div class="notifications-status__secsessed js-notifications-status__secsessed is-hidden status--success">Подключено</div>
            </div>
        </div>
        <div class="notifications-accordion-body js-notifications-accordion-body is-hidden">
            <div class="accordion-body__inner register-form__row">-->
                                    <!-- капча -->
                                    <!--<div class="register-form__row js-capcha-show-container">
        <div class="data-card__form-button data-card__form-button--grow txt-input__input">
            <input type="text" class="txt-input__field input req js-capcha-input" placeholder="Введите капчу">
            <div class="txt-input__required txt-input__required--error txt-input__required--dbl">Текст ошибки для поля</div>
        </div>
        <div class="data-card__form-button data-card__form-button--grow capcha-image js-capcha-image">
            <img src="/images/capcha.png" alt="">
            <div class="data-card__form-button" style="display: none;">
                <button type="button" class="button button--th-main js-poison-code">Отправить снова</button>
            </div>
        </div>
        <button type="button" class="data-card__form-button data-card__form-button--lg button button--th-main js-capcha-next-trigger" style="display: none;">OK</button>
    </div>-->
                                    <!-- кнопка для отправки кода -->
                                    <!--<a href="#dataCard_main_phone-20" class="js-notifications-item-hidden-block data-card__form-button data-card__form-button--grow button button--th-second js-capcha-hidden-block-entering js-precaptcha-cancel-btn" data-toggle="collapse" style="display: none;">Отменить</a>
    <button data-toggle="collapse" data-target="#dataCard_info-block-phone_20" type="button" class="data-card__form-button data-card__form-button--grow button button--th-main js-poison-code js-capcha-show-hidden-blocks js-capcha-hidden-block js-precaptcha-hide-cancel-btn js-notifications-capcha-timer" style="display: none;">
        Отправить<br>код
    </button>-->
                                    <!-- код -->
                                    <!--<div class="register-form__row js-connect-edm js-code-inner" style="display: none;">
                                        <label class="txt-input data-card__form-button data-card__form-button--grow">
                                            <input class="input js-code-input" type="text" placeholder="код">
                                            <div class="txt-input__required txt-input__required--success txt-input__required--dbl">Код введен верно</div>
                                            <div class="txt-input__required txt-input__required--error txt-input__required--dbl">Код введен неверно</div>
                                        </label>
                                        <div class="data-card__form-button data-card__form-button--grow data-card__form-button--flex timer-container-sm">
                                            <button data-toggle="collapse" data-target="#dataCard_info-block-phone_20" type="button" class="js-notifications-code-sumbit data-card__form-button data-card__form-button--grow button button--th-main timer-container-sm__btn js-code-submit js-make-input-readonly">
                                                OK
                                                <span class="form-timer form-timer--light js-timer">
                                                    <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                        <path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
                                                                M 50, 50
                                                                m -45, 0
                                                                a 45,45 0 1,0 90,0
                                                                a 45,45 0 1,0 -90,0
                                                                "></path>
                                                    </svg>
                                                    <span class="js-timer-count form-timer__count">
                                                    </span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <button type="button" class="data-card__form-button button button--th-main js-poison-code js-poison-code-again" style="display: none;">Отправить<br>еще раз</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="notifications-info-block js-notifications-info-block-static">
                        <div class="info-block-with-icon">
                            <div class="info-block-with-icon__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                </svg>
                            </div>
                            <div class="info-block-with-icon__text">
                                Дата рассылки 20-25 число месяца. Для рассылки требуется добавить почту и подтвердить её
                            </div>
                        </div>
                    </div>

                    <div id="dataCard_info-block-phone_20" class="notifications-info-block accordion-body collapse">
                        <div class="info-block-with-icon">
                            <div class="info-block-with-icon__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                </svg>
                            </div>
                            <div class="js-info-block-with-icon__text info-block-with-icon__text">
                                Введите код, который мы отправим на номер +7 (961)-701-0000
                            </div>
                        </div>
                    </div>
                    <div id="dataCard_info-block-text_20" class="notifications-info-block accordion-body collapse">
                        <div class="info-block-with-icon">
                            <div class="info-block-with-icon__icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                </svg>
                            </div>
                            <div class="info-block-with-icon__text">
                                Указанные изменения вступят в силу с 1 числа нового расчётного месяца
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
                                    <!-- Настройки списка рассылок -->
                                    <div class="settings__item head-card head-card--fill card">
                                        <div class="head-card__body">
                                            <div class="head-card__title h3">Настройки списка рассылок</div>
                                            <div class="head-card__caption">Подключите рассылку и получайте актуальную информацию по Вашим лицевым счетам по СМС, E-mail или другим способом</div>
                                        </div>
                                        <div class="head-card__icon">
                                            <img src="/images/card-head-icons/email.svg" alt="">
                                        </div>
                                    </div>

                                    <!------выводим в цикле подписки------->
                                    <div v-for="(notification, notification_index) in notificationObj.NotificationList" class="settings__item js-settings__item data-card block">
                                        <div class="data-card__head">
                                            <div class="data-card__subhead">
                                                <div class="data-card__title h3">{{notification.Name}}</div>
                                            </div>
                                            <div class="data-card__right data-card__right--revere">
                                                <label class="js-notification-switch switch switch--right">
                                                    <input class="switch__checkbox" 
                                                           :id="'checkbox_' + notification.OrderId"
                                                           v-on:click="switchChange(notification)"
                                                           data-toggle-switch="" :data-target="'#datacard_' + notification.OrderId" type="checkbox">
                                                    <div class="switch__label">
                                                        <div class="switch__text">Нет</div>
                                                        <div class="switch__text _last">Да</div>
                                                    </div>
                                                    <div class="switch__view"></div>
                                                </label>
                                            </div>
                                        </div>
                                        <!-- data-card__form data-card__form--sm -->
                                        <div :id="'datacard_' + notification.OrderId" class="notifications__card-form js-notifications__card-form  accordion-body collapse">
                                            <div class="data-card__caption">
                                                {{notification.Description}}
                                            </div>
                                            <div class="data-card__inner accordion-body__inner">
                                                <div class="small-form">
                                                    <div class="small-form__body">
                                                        <div class="notifications__select-block js-notifications__select-block b-select">
                                                            <div class="btn-group bootstrap-select b-select__picker">
                                                                <select class="b-select__picker selectpicker" data-style-base="button" tabindex="-98"
                                                                        :id="'notifytype_' + notification.OrderId"
                                                                        title=""
                                                                        v-on:change="changeNotifyType(notification.OrderId);">
                                                                    <option value="20">Не выбрано</option>
                                                                    <option v-bind:value="2" data-select="phone"
                                                                            data-content="<div class=&quot;notifications-select__wrapper&quot;>
																				<div class=&quot;notifications-select__left&quot;>
																					<svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
																						<g opacity=&quot;.5&quot;>
																							<rect width=&quot;14&quot; height=&quot;14&quot; rx=&quot;7&quot; fill=&quot;#343A4A&quot;/>
																							<g clip-path=&quot;url(#a)&quot; stroke=&quot;#fff&quot; stroke-width=&quot;.444&quot;>
																								<rect x=&quot;4.111&quot; y=&quot;3.222&quot; width=&quot;5.778&quot; height=&quot;7.556&quot; rx=&quot;.667&quot;/>
																								<path d=&quot;M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z&quot;/>
																							</g>
																						</g>
																						<defs>
																							<clipPath id=&quot;a&quot;>
																								<path fill=&quot;#fff&quot; transform=&quot;translate(3.889 3)&quot; d=&quot;M0 0h6.222v8H0z&quot;/>
																							</clipPath>
																						</defs>
																					</svg>
																				</div>
																				<div class=&quot;notifications-select__right&quot;>
																					<div class=&quot;notifications-select__text-m&quot;>SMS</div>
																				</div>
																			</div>">
														</option>
                                                                    <option v-bind:value="1" data-select="email"
                                                                            data-content="<div class=&quot;notifications-select__wrapper&quot;>
																					<div class=&quot;notifications-select__left&quot;>
																						<svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
																							<g opacity=&quot;.5&quot;>
																								<rect width=&quot;14&quot; height=&quot;14&quot; rx=&quot;7&quot; fill=&quot;#343A4A&quot;/>
																								<g clip-path=&quot;url(#a)&quot;>
																									<path d=&quot;M7 11.167c-.576 0-1.118-.11-1.625-.329a4.215 4.215 0 0 1-1.323-.89 4.198 4.198 0 0 1-.89-1.323A4.067 4.067 0 0 1 2.833 7c0-.576.11-1.118.329-1.625.219-.507.516-.948.89-1.323a4.202 4.202 0 0 1 1.323-.89A4.059 4.059 0 0 1 7 2.833c.576 0 1.118.11 1.625.329.508.219.949.515 1.323.89s.671.816.89 1.323c.22.507.33 1.049.329 1.625v.604c0 .41-.14.759-.422 1.047a1.39 1.39 0 0 1-1.037.432c-.243 0-.472-.052-.687-.156a1.468 1.468 0 0 1-.542-.448 2.007 2.007 0 0 1-.682.454c-.254.1-.52.15-.797.15a2.007 2.007 0 0 1-1.474-.61A2.01 2.01 0 0 1 4.916 7c0-.576.204-1.067.61-1.474.407-.406.898-.61 1.474-.61a2.01 2.01 0 0 1 1.474.61c.407.407.61.898.61 1.474v.604c0 .18.058.333.176.458a.59.59 0 0 0 .448.188.59.59 0 0 0 .448-.188.643.643 0 0 0 .177-.458V7c0-.93-.322-1.719-.968-2.365C8.719 3.99 7.93 3.667 7 3.667c-.93 0-1.719.323-2.365.968C3.99 5.281 3.667 6.07 3.667 7c0 .93.323 1.719.968 2.365.646.645 1.434.968 2.365.968h2.083v.834H7ZM7 8.25c.347 0 .642-.122.885-.365.244-.243.365-.538.365-.885s-.121-.642-.365-.885A1.205 1.205 0 0 0 7 5.75c-.347 0-.642.122-.885.365A1.205 1.205 0 0 0 5.75 7c0 .347.122.642.365.885s.538.365.885.365Z&quot; fill=&quot;#fff&quot;/>
																								</g>
																							</g>
																							<defs>
																								<clipPath id=&quot;a&quot;>
																									<path fill=&quot;#fff&quot; transform=&quot;translate(2 2)&quot; d=&quot;M0 0h10v10H0z&quot;/>
																								</clipPath>
																							</defs>
																						</svg>
																					</div>
																					<div class=&quot;notifications-select__right&quot;>
																						<div class=&quot;notifications-select__text-m&quot;>E-mail</div>
																					</div>
																				</div>">
														</option>
                                                                    <option v-bind:value="0" data-select="push"
                                                                            data-content="<div class='notifications-select__wrapper'>
																				<div class='notifications-select__left'>
																					<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none'>
																						<g opacity='.5'>
																							<rect width='14' height='14' rx='7' fill='#343A4A'/>
																							<g clip-path='url(#a)' stroke='#fff' stroke-width='.444'>
																								<rect x='4.111' y='3.222' width='5.778' height='7.556' rx='.667'/>
																								<path d='M8.63 4.185H5.37a.296.296 0 0 0-.296.296v3.26c0 .163.133.296.296.296h3.26a.296.296 0 0 0 .296-.296V4.48a.296.296 0 0 0-.297-.296Zm-2.964 4.74H5.37a.296.296 0 0 0-.296.297v.297c0 .163.133.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Zm1.482 0h-.296a.296.296 0 0 0-.297.297v.297c0 .163.133.296.297.296h.296a.296.296 0 0 0 .296-.296v-.297a.296.296 0 0 0-.296-.296Zm1.481 0h-.296a.296.296 0 0 0-.296.297v.297c0 .163.132.296.296.296h.296a.296.296 0 0 0 .297-.296v-.297a.296.296 0 0 0-.297-.296Z'/>
																							</g>
																						</g>
																						<defs>
																							<clipPath id='a'>
																								<path fill='#fff' transform='translate(3.889 3)' d='M0 0h6.222v8H0z'/>
																							</clipPath>
																						</defs>
																					</svg>
																				</div>
																				<div class='notifications-select__right'>
																					<div class='notifications-select__text-m'>Push-сообщение</div>
																					<span class='notifications-select__text-xs'>В мобильном приложении</span>
																				</div>
																			</div>">
														</option>
                                                                    <!--<option data-divider="true"></option>
                                <option v-bind:value="3" data-select="telegram" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                                <div class=&quot;notifications-select__left&quot;>
                                                    <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                                        <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                            <path d=&quot;M9.855 4.183h.01c.097 0 .187.03.261.083l-.001-.001c.054.047.09.113.099.187v.001a1.186 1.186 0 0 1 .011.278v-.004c-.104 1.101-.558 3.772-.789 5.004-.097.522-.29.697-.475.714-.404.037-.71-.267-1.102-.524-.613-.402-.96-.652-1.554-1.044-.687-.452-.241-.702.15-1.108.103-.107 1.883-1.726 1.918-1.873a.143.143 0 0 0-.033-.123.158.158 0 0 0-.085-.025.17.17 0 0 0-.06.011h.001c-.061.013-1.04.66-2.936 1.94a1.304 1.304 0 0 1-.752.278h-.003A4.9 4.9 0 0 1 3.4 7.711l.035.01c-.436-.141-.783-.216-.753-.457.016-.125.188-.253.518-.384A324.895 324.895 0 0 1 7.258 5.13a10.517 10.517 0 0 1 2.523-.934l.074-.014ZM6.977-.007a7 7 0 1 0 .033 0h-.033Z&quot; fill=&quot;#343A4A&quot;/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id=&quot;a&quot;>
                                                                <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </div>
                                                <div class=&quot;notifications-select__right&quot;>
                                                    <div class=&quot;notifications-select__text-m&quot;>Telegram</div>
                                                </div>
                                            </div>">
                    </option>
                                <option v-bind:value="4" data-select="vk" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                                <div class=&quot;notifications-select__left&quot;>
                                                    <svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot;>
                                                        <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                            <path d=&quot;M11.301 9.988h-1.017c-.385 0-.504-.307-1.195-1.007-.603-.584-.87-.662-1.017-.662-.208 0-.267.06-.267.346v.918c0 .247-.079.395-.73.395a3.966 3.966 0 0 1-3.102-1.85l-.01-.017a8.148 8.148 0 0 1-1.6-3.333l-.011-.054c0-.148.06-.287.346-.287h1.017c.256 0 .355.119.455.395.503 1.452 1.343 2.726 1.689 2.726.128 0 .187-.06.187-.385V5.671c-.04-.692-.405-.75-.405-.997a.245.245 0 0 1 .257-.237h1.6c.217 0 .296.118.296.375v2.025c0 .217.1.296.158.296.129 0 .238-.079.475-.315.491-.601.912-1.288 1.233-2.029l.021-.056a.452.452 0 0 1 .42-.287l.026.001h-.001 1.017c.306 0 .375.158.306.376-.408.898-.866 1.67-1.397 2.385l.024-.035c-.108.178-.148.257 0 .455.108.148.464.454.701.73.343.34.63.735.848 1.17l.011.027c.1.285-.05.434-.336.434l.001-.001ZM9.15.002H4.852C.93.002.002.93.002 4.852v4.296c0 3.921.929 4.85 4.85 4.85h4.297c3.92 0 4.85-.928 4.85-4.85V4.851c0-3.92-.94-4.85-4.85-4.85Z&quot; fill=&quot;#343A4A&quot;/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id=&quot;a&quot;>
                                                                <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </div>
                                                <div class=&quot;notifications-select__right&quot;>
                                                    <div class=&quot;notifications-select__text-m&quot;>ВКонтакте</div>
                                                </div>
                                            </div>">
                    </option>
                                <option v-bind:value="5" data-select="whatsapp" data-content="<div class=&quot;notifications-select__wrapper&quot;>
                                                <div class=&quot;notifications-select__left&quot;>
                                                    <svg width=&quot;14&quot; height=&quot;14&quot; fill=&quot;none&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;>
                                                        <g opacity=&quot;.5&quot; clip-path=&quot;url(#a)&quot;>
                                                            <path fill-rule=&quot;evenodd&quot; clip-rule=&quot;evenodd&quot; d=&quot;M6.998 0C3.139 0 0 3.14 0 7c0 1.53.494 2.95 1.333 4.103l-.872 2.6 2.69-.86A6.944 6.944 0 0 0 7.002 14C10.861 14 14 10.86 14 7s-3.139-7-6.998-7h-.004ZM5.044 3.556c-.136-.325-.239-.338-.444-.346a3.948 3.948 0 0 0-.235-.008c-.268 0-.547.078-.716.25-.206.21-.716.7-.716 1.704 0 1.005.733 1.976.831 2.112.103.135 1.428 2.226 3.485 3.078 1.608.666 2.086.605 2.452.527.535-.116 1.205-.51 1.374-.988.169-.478.169-.885.12-.971-.05-.087-.186-.136-.392-.24-.205-.102-1.205-.596-1.394-.662-.185-.07-.362-.045-.502.153-.198.275-.39.555-.547.724-.124.132-.325.148-.494.078-.226-.094-.86-.317-1.642-1.012-.604-.54-1.016-1.21-1.135-1.412-.12-.205-.012-.325.082-.436.103-.127.202-.218.305-.337.103-.12.16-.181.226-.321.07-.136.02-.276-.029-.379-.05-.103-.46-1.107-.63-1.514Z&quot; fill=&quot;#343A4A&quot;/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id=&quot;a&quot;>
                                                                <path fill=&quot;#fff&quot; d=&quot;M0 0h14v14H0z&quot;/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </div>
                                                <div class=&quot;notifications-select__right&quot;>
                                                    <div class=&quot;notifications-select__text-m&quot;>WhatsApp</div>
                                                </div>
                                            </div>">
                    </option>-->
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="notifications-add__input-block declarer-add__input-block declarer-add__input-block--medium declarer-add__input-block--notebook-half js-sub-block-form js-capcha-container js-code-container js-form js-valid-input-container js-timer-container">

                                                            <div v-if="notifyTypeSelected[notification.OrderId]=='2' && showPhoneDiv[notification.OrderId]" 
                                                                 class="js-notifications-input-block notifications-input-block declarer-add__input declarer-add__input--relative"
                                                                 :id="'phone_' + notification.OrderId">
                                                                <input class="js-notifications-input-phone notifications-input-phone txt-input__field input req js-base-input"
                                                                       type="text" v-model="phone" data-mask-phone=""
                                                                        v-on:change="changeContact(2, notification)"
                                                                        v-on:input="changeContact(2, notification)"
                                                                       >
                                                                <div class="notifications__status-wrapper status--error"
                                                                     :class="isValidatePhone(phone) ? '':'div_disabled'">

                                                                    <a v-if="((!notificationObj.PhoneNumberConfirmed || notificationObj.PhoneNumber=='') && isPhoneVerified<1) || phoneChanged"
                                                                       :id="'2confirm_' + notification.OrderId"
                                                                       v-on:click="verifyContact(2, notification.OrderId)"
                                                                       :href="'#dataCard_main_phone-'+ notification.OrderId"
                                                                       class="js-notifications-confirm-btn notifications-confirm-btn link link--present declarer-add__input-confirm-btn js-input-confirm-btn"
                                                                       data-toggle="collapse" style="top:0%">
                                                                        <span class="link__text">Подтвердить</span>
                                                                    </a>
                                                                    <button v-if="((notificationObj.PhoneNumberConfirmed && notificationObj.PhoneNumber!='') ||  isPhoneVerified==1)
                                                                            && !notification.SmsActive && !subscrSmsActive[notification.OrderId] && !phoneChanged"
                                                                            :id="'2toactive_' + notification.OrderId"
                                                                            v-on:click="activeSubscr(notification.Code,2,notification.OrderId)"
                                                                            type="button" class="js-notifications-confirm-btn-sucsess notifications-confirm-btn-sucsess"
                                                                            data-target="#dataCard_info-block-text_3" data-toggle="collapse">
                                                                        <span class="link__text">Подключить</span>
                                                                    </button>
                                                                    <a href="" class="button notifications-loader js-form-payment is-overlay is-hidden"></a>
                                                                    <div v-if="((notificationObj.PhoneNumberConfirmed && notificationObj.PhoneNumber!='') || isPhoneVerified==1)
                                                                         && (notification.SmsActive || subscrSmsActive[notification.OrderId]) && !phoneChanged"
                                                                         :id="'2active_' + notification.OrderId"
                                                                         class="notifications-status__secsessed js-notifications-status__secsessed status--success">Подключено</div>
                                                                </div>
                                                            </div>
                                                            <div v-if="notifyTypeSelected[notification.OrderId]=='1' && showEmailDiv[notification.OrderId]" 
                                                                 class="js-notifications-input-block notifications-input-block declarer-add__input declarer-add__input--relative"
                                                                 :id="'email_' + notification.OrderId">
                                                                <input class="js-notifications-input-email notifications-input-email txt-input__field input req js-valid-input"
                                                                       :class="emailType(email) ? '':'is-error'"
                                                                       type="mail" v-model="email" placeholder="E-mail" data-type="email"
                                                                       v-on:change="changeContact(1, notification)"
                                                                       v-on:input="changeContact(1, notification)"
                                                                       >
                                                                <div class="notifications__status-wrapper status--error"
                                                                     :class="emailType(email) ? '':'div_disabled'">

                                                                    <a v-if="((!notificationObj.EmailConfirmed || notificationObj.Email=='') && isEmailVerified<1) || emailChanged"
                                                                       :id="'1confirm_' + notification.OrderId"
                                                                       v-on:click="verifyContact(1, notification.OrderId)"
                                                                       :href="emailType(email) ? '#dataCard_main_phone-'+ notification.OrderId : '#'"
                                                                       class="js-notifications-confirm-btn notifications-confirm-btn link link--present declarer-add__input-confirm-btn js-input-confirm-btn"
                                                                       data-toggle="collapse" style="top:0%">
                                                                        <span class="link__text">Подтвердить</span>
                                                                    </a>
                                                                    <button v-if="((notificationObj.EmailConfirmed && notificationObj.Email!='') || isEmailVerified==1)
                                                                            && !notification.EmailActive && !subscrEmailActive[notification.OrderId] && !emailChanged"
                                                                            :id="'1toactive_' + notification.OrderId"
                                                                            v-on:click="activeSubscr(notification.Code,1,notification.OrderId)"
                                                                            type="button" class="js-notifications-confirm-btn-sucsess notifications-confirm-btn-sucsess " data-target="#dataCard_info-block-text_3" data-toggle="collapse">
                                                                        <span class="link__text">Подключить</span>
                                                                    </button>
                                                                    <a href="" class="button notifications-loader js-form-payment is-overlay is-hidden"></a>
                                                                    <div v-if="((notificationObj.EmailConfirmed && notificationObj.Email!='')  || isEmailVerified==1)
                                                                         && (notification.EmailActive || subscrEmailActive[notification.OrderId]) && !emailChanged"
                                                                         :id="'1active_' + notification.OrderId"
                                                                         class="notifications-status__secsessed js-notifications-status__secsessed status--success">Подключено</div>
                                                                </div>
                                                            </div>
                                                            <div v-if="notifyTypeSelected[notification.OrderId]=='0' && showPushDiv[notification.OrderId]" 
                                                                 class="js-notifications-input-block notifications-input-block declarer-add__input declarer-add__input--relative"
                                                                 :id="'push_' + notification.OrderId">
                                                                <input class="js-notifications-input-phone notifications-input-phone txt-input__field input req js-base-input"
                                                                       type="text" v-model="phone" data-mask-phone=""
                                                                      v-on:change="changeContact(0, notification)"
                                                                      v-on:input="changeContact(0, notification)"                                                                       
                                                                       >
                                                                <div class="notifications__status-wrapper status--error"
                                                                     :class="isValidatePhone(phone) ? '':'div_disabled'">

                                                                    <a v-if="((!notificationObj.PhoneNumberConfirmed || notificationObj.PhoneNumber=='') && isPhoneVerified<1) || phoneChanged"
                                                                       :id="'0confirm_' + notification.OrderId"
                                                                       v-on:click="verifyContact(0, notification.OrderId)"
                                                                       :href="'#dataCard_main_phone-'+ notification.OrderId"
                                                                       class="js-notifications-confirm-btn notifications-confirm-btn link link--present declarer-add__input-confirm-btn js-input-confirm-btn"
                                                                       data-toggle="collapse" style="top:0%">
                                                                        <span class="link__text">Подтвердить</span>
                                                                    </a>

                                                                    <button v-if="((notificationObj.PhoneNumberConfirmed && notificationObj.PhoneNumber!='') || isPhoneVerified==1)
                                                                            && !notification.PushActive && !subscrPushActive[notification.OrderId] && !phoneChanged"
                                                                            :id="'0toactive_' + notification.OrderId"
                                                                            v-on:click="activeSubscr(notification.Code,0,notification.OrderId)"
                                                                            type="button" class="js-notifications-confirm-btn-sucsess notifications-confirm-btn-sucsess" data-target="#dataCard_info-block-text_3" data-toggle="collapse">
                                                                        <span class="link__text">Подключить</span>
                                                                    </button>
                                                                    <a href="" class="button notifications-loader js-form-payment is-overlay is-hidden"></a>
                                                                    <div v-if="((notificationObj.PhoneNumberConfirmed && notificationObj.PhoneNumber!='') || isPhoneVerified==1)
                                                                         && (notification.PushActive || subscrPushActive[notification.OrderId]) && !phoneChanged"
                                                                         :id="'0active_' + notification.OrderId"
                                                                         class="notifications-status__secsessed js-notifications-status__secsessed status--success">Подключено</div>
                                                                </div>
                                                            </div>
                                                            <div class="notifications-accordion-body js-notifications-accordion-body is-hidden"
                                                                 :id="'checkCaptchaVerifyDiv_'+ notification.OrderId">
                                                                <!-- <div id="dataCard_main_phone" class="data-card__form data-card__form--full accordion-body collapse"> -->
                                                                <div class="accordion-body__inner register-form__row">
                                                                    <!-- капча -->
                                                                    <div v-if="showCapchaDiv[notification.OrderId]"
                                                                         class="register-form__row js-capcha-show-container" :id="'checkCaptchaDiv_'+ notification.OrderId">
                                                                        <div class="data-card__form-button data-card__form-button--grow txt-input__input"
                                                                             style="width:240px">
                                                                            <input type="text" class="txt-input__field input req js-capcha-input" placeholder="Введите капчу"
                                                                                   v-on:change="checkCaptchaButtonAction(notification)"
                                                                                   v-on:input="checkCaptchaButtonAction(notification)"
                                                                                   :id="'checkCaptcha_'+ notification.OrderId"
                                                                                   maxlength="8"
                                                                                   v-model="inputCapchaCode">
                                                                            <!--<div class="txt-input__required--success" v-if="checkCapchaCode">Код введен верно</div>
            <div class="txt-input__required--error" v-if="!checkCapchaCode">{{capchaError}}</div>-->
                                                                            <div v-if="!checkCapchaCode"
                                                                                 class="txt-input__required txt-input__required--error txt-input__required--dbl">
                                                                                {{capchaError}}
                                                                            </div>
                                                                        </div>
                                                                        <div class="data-card__form-button data-card__form-button--grow capcha-image js-capcha-image"
                                                                             :id="'captchaImage_'+ notification.OrderId"
                                                                             style="width:240px">
                                                                            <img src="/Profiles/Captcha">
                                                                            <div class="data-card__form-button" style="display: none;">
                                                                                <button type="button" class="button button--th-main js-poison-code">Отправить снова</button>
                                                                            </div>
                                                                        </div>
                                                                        <button type="button"
                                                                                class="data-card__form-button data-card__form-button--lg button button--th-main js-capcha-next-trigger"
                                                                                :id="'checkCaptchaButton_'+ notification.OrderId"
                                                                                v-on:click="checkCaptcha"
                                                                                style="width:240px; display: none;">
                                                                            OK
                                                                        </button>
                                                                    </div>

                                                                    <!-- кнопка для отправки кода -->
                                                                    <a v-if="showSendCodeDiv[notification.OrderId]"
                                                                       :href="'#dataCard_main_phone-'+ notification.OrderId"
                                                                       class="js-notifications-item-hidden-block data-card__form-button data-card__form-button--grow button button--th-second js-capcha-hidden-block-entering js-precaptcha-cancel-btn is-hidden"
                                                                       data-toggle="collapse"
                                                                       :id="'verifyCancelButton_'+ notification.OrderId"
                                                                       v-on:click="cancelVerify(notification.OrderId)">
                                                                        Отменить
                                                                    </a>
                                                                    <button v-if="showSendCodeDiv[notification.OrderId]"
                                                                            data-toggle="collapse" :data-target="'#dataCard_info-block-phone_'+ notification.OrderId" type="button"
                                                                            class="data-card__form-button data-card__form-button--grow button button--th-main js-poison-code js-capcha-show-hidden-blocks js-capcha-hidden-block js-precaptcha-hide-cancel-btn js-notifications-capcha-timer is-hidden"
                                                                            :id="'sendCodeButton_'+ notification.OrderId"
                                                                            v-on:click="verifyStart">
                                                                        Отправить<br>код
                                                                    </button>
                                                                    <!-- код -->
                                                                    <div v-if="showInputCodeDiv[notification.OrderId]"
                                                                         class="register-form__row js-connect-edm js-code-inner"
                                                                         :id="'inputCodeDiv_'+ notification.OrderId"
                                                                         style="width:480px">
                                                                        <label class="txt-input data-card__form-button data-card__form-button--grow"
                                                                               style="display: inline-flex;">
                                                                            <input class="input js-code-input" type="text" placeholder="код"
                                                                                   v-on:change="checkVerifyCodeButtonAction(notification)"
                                                                                   v-on:input="checkVerifyCodeButtonAction(notification)"
                                                                                   :id="'inputVerifyCode_'+ notification.OrderId"
                                                                                   maxlength="8"
                                                                                   v-model="inputCode">
                                                                            <!--<div class="txt-input__required txt-input__required--success txt-input__required--dbl">Код введен верно</div>
            <div class="txt-input__required txt-input__required--error txt-input__required--dbl">Код введен неверно</div>-->
                                                                            <!--<div class="txt-input__required txt-input__required--error txt-input__required--dbl" style="display: block"
                 v-if="isPhoneVerified==-1 || isEmailVerified==-1">{{codeVerifyError}}</div>-->
                                                                        </label>
                                                                        <div class="data-card__form-button data-card__form-button--grow data-card__form-button--flex timer-container-sm"
                                                                             style="display: inline-flex; width: 215px">
                                                                            <button data-toggle="collapse" data-target="'#dataCard_info-block-phone_'+ notification.OrderId" type="button"
                                                                                    v-on:click="verifyCheckCode"
                                                                                    :id="'checkVerifyCodeButton_'+ notification.OrderId"
                                                                                    class="js-notifications-code-sumbit data-card__form-button data-card__form-button--grow button button--th-main timer-container-sm__btn js-code-submit js-make-input-readonly">
                                                                                OK
                                                                                <span class="form-timer form-timer--light js-timer is-show">
                                                                                    <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                                                                                        <path stroke-dasharray="283" class="form-timer__circle js-timer-circle" d="
														                                	M 50, 50
														                                	m -45, 0
													                                		a 45,45 0 1,0 90,0
													                                		a 45,45 0 1,0 -90,0
														                            	"></path>
                                                                                    </svg>
                                                                                    <span class="js-timer-count form-timer__count" data-circle-timer-time>
                                                                                        {{counter}}
                                                                                    </span>
                                                                                </span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div class="txt-input__required txt-input__required--error txt-input__required--dbl" style="display: block;position:relative"
                                                                         v-if="isPhoneVerified==-1 || isEmailVerified==-1">{{codeVerifyError}}</div>

                                                                    <button v-if="showSendAgain[notification.OrderId]"
                                                                            type="button" class="data-card__form-button button button--th-main js-poison-code js-poison-code-again"
                                                                            style="width:240px;"
                                                                            :id="'sendCodeAgainButton_'+ notification.OrderId"
                                                                            v-on:click="verifyStart">
                                                                        Отправить<br>еще раз
                                                                    </button>
                                                                </div>
                                                                <!-- </div> -->
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="notifications-info-block js-notifications-info-block-static" v-if="notification.Code==10">
                                                        <div class="info-block-with-icon">
                                                            <div class="info-block-with-icon__icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                                                </svg>
                                                            </div>
                                                            <div class="info-block-with-icon__text">
                                                                Дата рассылки 20-25 число месяца
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="dataCard_info-block-phone_3" class="notifications-info-block accordion-body collapse">
                                                        <div class="info-block-with-icon">
                                                            <div class="info-block-with-icon__icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                                                </svg>
                                                            </div>
                                                            <div class="js-info-block-with-icon__text info-block-with-icon__text">
                                                                Введите код, который мы отправим на номер {{phone}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="dataCard_info-block-text_3" class="notifications-info-block accordion-body collapse">
                                                        <div class="info-block-with-icon">
                                                            <div class="info-block-with-icon__icon">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                    <circle cx="8" cy="8" r="7.4" stroke="#0078A8" stroke-width="1.2"></circle>
                                                                    <path d="M7.438 4h1.161l-.083 5.026H7.52L7.438 4Zm.578 7.594a.668.668 0 0 1-.683-.672.668.668 0 0 1 .682-.672c.195 0 .358.064.49.193a.642.642 0 0 1 .198.479c0 .19-.066.35-.198.479a.674.674 0 0 1-.49.193Z" fill="#0078A8"></path>
                                                                </svg>
                                                            </div>
                                                            <div class="info-block-with-icon__text">
                                                                Указанные изменения вступят в силу с 1 числа нового расчётного месяца
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--------------->
                                    <!-- Новости СГК -->
                                    <div class="settings__item js-settings__item data-card data-card--end block" id="Code_1">
                                        <div class="data-card__head data-card__head--link">
                                            <div class="data-card__subhead">
                                                <div class="data-card__title h3">Новости СГК Онлайн</div>
                                                <div class="data-card__caption">
                                                    Подписаться на новости СГК Онлайн
                                                </div>
                                            </div>
                                            <div class="data-card__right data-card__right--revere">
                                                <a href="https://sibgenco.online/" class="button button--th-main"  target="_blank" rel="noopener">Перейти</a>
                                            </div>
                                        </div>
                                    </div>





                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    
</template>
<script>
    import ProfilesHeader from './ProfilesHeader.vue';
    import ErrorAlert from './ErrorAlert.vue';

	const { required, minLength, maxLength, sameAs } = window.validators
	const { validationMixin } = window.vuelidate
	
	import MaskedInput from 'vue-masked-input';

	import { formatMobileNumberToDigits } from '../../../../wwwroot/app/epp.utils';
 
    export default {

		mixins: [validationMixin],
	
		name: 'notificationsettings',
        props: ['notifications'],

        components: {
            'app-header': ProfilesHeader,
            'app-error-alert': ErrorAlert,
			'masked-input': MaskedInput,
       
        },

        created: function () {
            this.loadData();
        },

        data: function () {
            return {
                settings: { name: this.$options.name },
                isLoadData: false,

                notificationObj: {},
                subscrActive: [],
                switchChecked: [],
                subscrSmsActive: [],
                subscrEmailActive: [],
                subscrPushActive: [],
				subscrCode: [],
                phoneConfirmed: false,
                emailConfirmed: false,
                phone: "",
                email: "",
                notifyTypeSelected: [],

                inputCapchaCode: "",
				checkCapchaCode: false,
                capchaError: "",
                countCheck: 1,
                curOrderId: 0,
                curNotifyType: -1,
                curCode: -1,

                counter: 100,
				lifeTimeCode: 300,

				/// верификация телефона
				phoneVerifyError: '',
				isPhoneVerified: 0,
				phoneCode: '',
				/// верификация email
				emailVerifyError: '',
				isEmailVerified: 0,
				emailCode: '',
                inputCode: '',
                phoneChanged: false,
				emailChanged: false,

                showCapchaDiv: [],
                showSendCodeDiv: [],
                showInputCodeDiv: [],

				showSendAgain:[],

                showPhoneDiv: [],
                showEmailDiv: [],
				showPushDiv: [],

                isServerVerify: false,
				isValidateErrors: false,
				serverMessage: '',
                serverResponse: [],
                codeVerifyError:'',

				//phoneMask: {
				//	pattern: '\+7-w11-111-1111',
				//	formatCharacters: {
				//		'w': {
				//			validate: function (char) { return /\9/.test(char) },
				//			transform: function (char) { return char.toLowerCase() }
				//		}
				//	}
				//},
            }
        },
        filters: {
            formatDate: function (value) {
                if (value) {
                    var d = value.substring(8, 10);
                    var m = value.substring(5, 7);
                    var y = value.substring(0, 4);
                    return d + "." + m + "." + y;
                }
            },

            formatTime: function (value) {
                if (value) {
                    var time = value.substring(11, 16);
                    return time;
                }
            },
        },
        methods: {

			verifyContact: function (notifyType, orderId) {
				var id = 'checkCaptchaVerifyDiv_' + + orderId;
				var elem = document.getElementById(id);
				if (elem != undefined) {
					$(elem).removeClass('is-hidden');
				}
				this.curNotifyType = notifyType;

				//this.hideVerifyCodeButtons(orderId);
				//            this.hideInputCodeDev(orderId);
				//            this.hideSendCodeAgainButton(orderId);

				//this.showCapchaDiv[orderId] = true;
				//this.showSendCodeDiv[orderId] = false;
				//            this.showInputCodeDiv[orderId] = false;
				//this.$forceUpdate();

				if (this.curNotifyType == 0) {//пуш
					this.showHidePushBlock(false, orderId);
				}
				if (this.curNotifyType == 1) {//емэйл
					this.showHideEmailBlock(false, orderId);
				}
				if (this.curNotifyType == 2) {//телефон
					this.showHidePhoneBlock(false, orderId);
				}

				this.inputCapchaCode = "";
				this.checkCapchaCode = false;
				this.capchaError = "";
				this.showHideCaptchaBlock(true, orderId);
				this.showHideSendCodeBlock(false, orderId);
				this.showHideInputCodeBlock(false, orderId);
			},

			cancelVerify: function (orderId) {
				//this.hideVerifyCodeButtons(orderId);
				//this.hideCapchaDiv(orderId);
				//this.hideCapchaVerifyDiv(orderId);
				//this.hideInputCodeDev(orderId);

				this.showHideCaptchaBlock(false, orderId);
				this.showHideSendCodeBlock(false, orderId);
				this.showHideInputCodeBlock(false, orderId);
				this.inputCapchaCode = "";
				this.checkCapchaCode = false;
                this.capchaError = "";

				if (this.curNotifyType == 0) {//пуш
					this.showHidePushBlock(true, orderId);
				}
				if (this.curNotifyType == 1) {//емэйл
					this.showHideEmailBlock(true, orderId);
				}
				if (this.curNotifyType == 2) {//телефон
					this.showHidePhoneBlock(true, orderId);
				}

				//this.showCapchaDiv[orderId] = false;
				//this.showSendCodeDiv[orderId] = false;
				//this.showInputCodeDiv[orderId] = false;
				//this.$forceUpdate();

				//this.switchHandle(false, orderId);
			},

			showHidePhoneBlock: function (show, orderId) {
				if (show == true) {
					this.showPhoneDiv[orderId] = true;
				}
				if (show == false) {
					this.showPhoneDiv[orderId] = false;
				}
				this.$forceUpdate();
            },

			showHideEmailBlock: function (show, orderId) {
				if (show == true) {
					this.showEmailDiv[orderId] = true;
				}
				if (show == false) {
					this.showEmailDiv[orderId] = false;
				}
                this.$forceUpdate();
            },

            showHidePushBlock: function (show, orderId) {
				if (show == true) {
					this.showPushDiv[orderId] = true;
				}
				if (show == false) {
					this.showPushDiv[orderId] = false;
				}
				this.$forceUpdate();
			},

	        showHideCaptchaBlock: function (show, orderId) {
                if (show == true) {
                    this.showCapchaDiv[orderId] = true;
                }
				if (show == false) {
					this.showCapchaDiv[orderId] = false;
                }
				this.$forceUpdate();
            },

            showHideSendCodeBlock: function (show, orderId) {
				if (show == true) {
					this.showSendCodeDiv[orderId] = true;
				}
				if (show == false) {
					this.showSendCodeDiv[orderId] = false;
				}
				this.$forceUpdate();
            },

			showHideInputCodeBlock: function (show, orderId) {
				if (show == true) {
					this.showInputCodeDiv[orderId] = true;
				}
				if (show == false) {
					this.showInputCodeDiv[orderId] = false;
                }
                this.$forceUpdate();
				console.log('showHideInputCodeBlock: showInputCodeDiv[orderId]=' + this.showInputCodeDiv[orderId]);
            },

			showHideSendCodeAgainBlock: function (show, orderId) {
				if (show == true) {
					this.showSendAgain[orderId] = true;
				}
				if (show == false) {
					this.showSendAgain[orderId] = false;
				}
				this.$forceUpdate();
			},



            switchChange:  function (notification) {
				var checkbox = document.getElementById('checkbox_' + notification.OrderId);
                //в случае отключения чекбокса -отключаем подписку полностью
                if (checkbox != undefined) {
                    if (checkbox.checked == false) {
			
                        this.notificationObj.NotificationList[notification.OrderId - 1].Active = false;
                        this.subscrActive[notification.OrderId] = false;
						
						if (notification.SmsActive == true || this.subscrSmsActive[notification.OrderId]==true) {
							this.deActiveSubscr(notification.Code, 2, notification.OrderId);
                            this.notificationObj.NotificationList[notification.OrderId - 1].SmsActive = false;
                            this.subscrSmsActive[notification.OrderId] = false;
                        }
						if (notification.EmailActive == true || this.subscrEmailActive[notification.OrderId]==true) {
							this.deActiveSubscr(notification.Code, 1, notification.OrderId);
                            this.notificationObj.NotificationList[notification.OrderId - 1].EmailActive = false;
                            this.subscrEmailActive[notification.OrderId] = false;

                        }
						if (notification.PushActive == true || this.subscrPushActive[notification.OrderId]==true) {
							this.deActiveSubscr(notification.Code, 0, notification.OrderId);
							this.notificationObj.NotificationList[notification.OrderId - 1].PushActive = false;
                            this.subscrPushActive[notification.OrderId] = false;
                        }
             
                    }
                    else {
                    }
                }
                this.$forceUpdate();
			
            },

			hideInput: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					input.style.display = 'none';
				}
			},

			showInput: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					input.style.display = 'block';
				}
            },

			hideBlock: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					input.style.display = 'none';
				}
			},

			showBlock: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					input.style.display = 'block';
				}
			},

			errorInput: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					$(input).addClass('is-error');
				}
			},

			noErrorInput: function (id) {
				var input = document.getElementById(id);
				if (input != undefined) {
					$(input).removeClass('is-error');
				}
			},

            errorCaptcha: function (orderId) {
                this.errorInput('checkCaptcha_' + orderId);
			},
			errorCode: function (orderId) {
				this.errorInput('inputVerifyCode_' + orderId);
			},

			hideCode: function (orderId) {
				this.hideInput('inputVerifyCode_' + orderId);
			},
			showCode: function (orderId) {
				this.showInput('inputVerifyCode_' + orderId);
			},
			noErrorCaptcha: function (orderId) {
				this.noErrorInput('checkCaptcha_' + orderId);
			},
			noErrorCode: function (orderId) {
				this.noErrorInput('inputVerifyCode_' + orderId);
            },

			showVerifyCodeButtons: function (orderId) {
				var verifyCancelButtonId = 'verifyCancelButton_' + orderId;
                var sendCodeButtonId = 'sendCodeButton_' + orderId;
				var elemVerifyCancelButton = document.getElementById(verifyCancelButtonId);
				if (elemVerifyCancelButton != undefined) {
					$(elemVerifyCancelButton).removeClass('is-hidden');
                }
				var elemSendCodeButton = document.getElementById(sendCodeButtonId);
				if (elemSendCodeButton != undefined) {
					$(elemSendCodeButton).removeClass('is-hidden');
				}
				this.showBlock(verifyCancelButtonId);
                this.showBlock(sendCodeButtonId);   

				//this.showCapchaDiv[orderId] = false;
				//this.showSendCodeDiv[orderId] = true;
				//this.showInputCodeDiv[orderId] = false;

                 this.showHideCaptchaBlock(false, orderId);
                 this.showHideSendCodeBlock(true, orderId);
                 this.showHideInputCodeBlock(false, orderId);
            },

			hideVerifyCodeButtons: function (orderId) {
				var verifyCancelButtonId = 'verifyCancelButton_' + orderId;
                var sendCodeButtonId = 'sendCodeButton_' + orderId;

                var elemVerifyCancelButton = document.getElementById(verifyCancelButtonId);
                if (elemVerifyCancelButton != undefined) {
                    $(elemVerifyCancelButton).addClass('is-hidden');
				}
				var elemSendCodeButton = document.getElementById(sendCodeButtonId);
                if (elemSendCodeButton != undefined) {
                    $(elemSendCodeButton).addClass('is-hidden');
				}
                this.hideBlock(verifyCancelButtonId);
                this.hideBlock(sendCodeButtonId);  

				this.showCapchaDiv[orderId] = false;
				this.showSendCodeDiv[orderId] = false;
                this.showInputCodeDiv[orderId] = false;
				console.log('hideVerifyCodeButtons: showInputCodeDiv[orderId]=' + this.showInputCodeDiv[orderId]);


                this.showHideCaptchaBlock(false, orderId);
                this.showHideSendCodeBlock(false, orderId);
                this.showHideInputCodeBlock(false, orderId);
            },

            showInputCodeDev: function (orderId) {               
				var inputCodeDivId = 'inputCodeDiv_' + orderId;
                this.showBlock(inputCodeDivId);
				console.log('showInputCodeDev: showBlock(' + 'inputCodeDiv_' + orderId+")");

                this.showHideCaptchaBlock(false, orderId);
                this.showHideSendCodeBlock(false, orderId);
                this.showHideInputCodeBlock(true, orderId);
            },

            hideInputCodeDev: function (orderId) {
				var inputCodeDivId = 'inputCodeDiv_' + orderId;
                this.hideBlock(inputCodeDivId);
				console.log('hideInputCodeDev: hideBlock(' + 'inputCodeDiv_' + orderId + ")");

                this.showHideCaptchaBlock(false, orderId);
                this.showHideSendCodeBlock(false, orderId);
                this.showHideInputCodeBlock(false, orderId);
            },

			showSendCodeAgainButton: function (orderId) {
                this.showHideCaptchaBlock(false, orderId);
                this.showHideSendCodeBlock(false, orderId);
                this.showHideInputCodeBlock(true, orderId);

				var sendCodeAgainButtonId = 'sendCodeAgainButton_' + orderId;
				this.showBlock(sendCodeAgainButtonId);
            },

			hideSendCodeAgainButton: function (orderId) {
 
				this.showHideCaptchaBlock(false, orderId);
				this.showHideSendCodeBlock(false, orderId);
				//this.showHideInputCodeBlock(false, orderId);

                var sendCodeAgainButtonId = 'sendCodeAgainButton_' + orderId;
				this.hideBlock(sendCodeAgainButtonId);
			},
           

			hideCapchaVerifyDiv: function (orderId) {
				var id = 'checkCaptchaVerifyDiv_' + + orderId;
				var elem = document.getElementById(id);
				if (elem != undefined) {
					$(elem).addClass('is-hidden');
				}
				//this.hideCapchaDiv(orderId);
				this.hideVerifyCodeButtons(orderId);
                this.hideInputCodeDev(orderId);
                this.hideSendCodeAgainButton(orderId);

				//this.showCapchaDiv[orderId] = false;
				//this.showSendCodeDiv[orderId] = false;
    //            this.showInputCodeDiv[orderId] = false;

				this.showHideCaptchaBlock(false, orderId);
				this.showHideSendCodeBlock(false, orderId);
				this.showHideInputCodeBlock(false, orderId);
			},

			//showCapchaDiv: function (orderId) {
			//	var checkCaptchaDivId = 'checkCaptchaDiv_' + orderId;
   //             this.showBlock(checkCaptchaDivId);

			//	this.showCapchaDiv[orderId] = true;
			//	this.showSendCodeDiv[orderId] = true;
			//	this.showInputCodeDiv[orderId] = true;
			//},

			//hideCapchaDiv: function (orderId) {
			//	var checkCaptchaDivId = 'checkCaptchaDiv_' + orderId;
   //             this.hideBlock(checkCaptchaDivId);

			//	this.showCapchaDiv[orderId] = false;
			//	this.showSendCodeDiv[orderId] = false;
			//	this.showInputCodeDiv[orderId] = false;
			//},

            verifyStart: function (event) {
                if (this.curNotifyType == 0 || this.curNotifyType == 2) {//телефон
                    this.phoneChanged = false;
					this.verifyPhoneStart(event);
				}
                if (this.curNotifyType == 1) {//емэйл
					this.emailChanged = false;
					this.verifyEmailStart(event);
				}
            },

			checkVerifyCodeButtonAction: function (notification) {
				//this.showIncorrectMessage = false;
				//this.showNotFindMessage = false;
				//this.showNotFindContacts = false;
                this.codeVerifyError = "";
     			var checkButton = document.getElementById('checkVerifyCodeButton_' + notification.OrderId);
				if (checkButton != undefined) {
					$(checkButton).addClass('is-disable');
                    if (this.inputCode.length > 2) {
						this.curOrderId = notification.OrderId;
						this.curCode = notification.Code;
                        $(checkButton).removeClass('is-disable');
                    }
				}
            },

            changeContact: function (notifyType, notification) {
				this.curNotifyType = notifyType;
	
                if (this.curNotifyType == 0) {//пуш
                    this.isPhoneVerified = 0;
                    this.phoneChanged = true;
				}
                if (this.curNotifyType == 1) {//емэйл
                    this.isEmailVerified = 0;
					this.emailChanged = true;
				}
				if (this.curNotifyType == 2) {//телефон
                    this.isPhoneVerified = 0;
					this.phoneChanged = true;
				}
            },

			checkCaptchaButtonAction: function (notification) {
	
                var checkCaptchaButton = document.getElementById('checkCaptchaButton_' + notification.OrderId);
                var captchaImage = document.getElementById('captchaImage_' + notification.OrderId);	
 
				if (checkCaptchaButton != undefined && captchaImage != undefined) {
					//checkCaptchaButton.style.display = 'block';
					captchaImage.style.display = 'block';
					checkCaptchaButton.style.display = 'none';
					$(checkCaptchaButton).addClass('is-disable');
                    if (this.inputCapchaCode.length > 5) {
						checkCaptchaButton.style.display = 'block';
                        this.curOrderId = notification.OrderId;
                        this.curCode = notification.Code;
                        $(checkCaptchaButton).removeClass('is-disable');
						if (captchaImage != undefined) {
							captchaImage.style.display = 'none';
						}
                    }
				} 
            },

            showHideCheckCaptchaButton: function (show, orderId) {
				var checkCaptchaButton = document.getElementById('checkCaptchaButton_' + orderId);

                if (checkCaptchaButton != undefined) {
                    if (show == true) {
                        checkCaptchaButton.style.display = 'block';
                    }
                    if (show == false) {
                        checkCaptchaButton.style.display = 'none';
                    }				
				} 
            },

            showHideCaptchaImage: function (show, orderId) {
				var captchaImage = document.getElementById('captchaImage_' + orderId);	
                if (captchaImage != undefined) {
                    if (show == true) {
                        captchaImage.style.display = 'block';
                    }
                    if (show == false) {
                        captchaImage.style.display = 'none';
                    }
                }
			},

			getRandomInt: function (min, max) {
				min = Math.ceil(min);
				max = Math.floor(max);
				return Math.floor(Math.random() * (max - min) + min);
			},

			checkCaptcha: function (event) {
				event.stopPropagation();

				console.log("checkCaptcha");

				const self = this;
				this.checkCapchaCode = false;
				this.capchaError = "";

                var count = this.getRandomInt(0, 100);
				var captchaImageId = '#captchaImage_' + this.curOrderId;

				axios.post('/Register/CheckCaptcha/' + self.inputCapchaCode)
					.then(function (response) {
						console.info('checkCaptcha', response);
						if (response.data.isSuccess) {

						}
						if (!response.data.isSuccess) {
							var countch = self.countCheck++;
							console.log("Count Check", countch);
							self.isValidateErrors = true;
							self.isServerVerify = false;
							self.checkCapchaCode = false;
							self.capchaError = "Код введен неверно";
							//self.activeStep6 = false;
							//self.showIncorrectMessage = true;
							//self.deActiveSteps(6);
							//self.failedAttempts5 = self.failedAttempts5 + 1;
							self.errorCaptcha(self.curOrderId);

							
							if (countch % 2 === 0) {
								var str = '<img src="/Profiles/Captcha/' + count + '">';
								console.log("String", str);
                                $(captchaImageId).html(str);
                                self.noErrorCaptcha(self.curOrderId);
								self.inputCapchaCode = "";
								self.checkCapchaCode = false;
								self.capchaError = "";
                                self.showHideCaptchaImage(true, self.curOrderId);
								self.showHideCheckCaptchaButton(false, self.curOrderId);
							}

						}
						else {
							self.checkCapchaCode = true;
							self.capchaError = "";
							//self.activeStep6 = true;
							//self.stepActive(6);
							//self.stepHide(5);
							//self.showIncorrectMessage = false;
							//self.showNotFindMessage = false;
							//self.showNotFindContacts = false;

                            self.noErrorCaptcha(self.curOrderId);
                            //self.showVerifyCodeButtons(self.curOrderId);
                            //self.hideCapchaDiv(self.curOrderId);
							
							self.showHideCaptchaBlock(false, self.curOrderId);
							self.showHideSendCodeBlock(true, self.curOrderId);
							self.showHideInputCodeBlock(false, self.curOrderId);
							//self.verifyStart(event);
						}
					})
					.catch(function (error) {
						self.isValidateErrors = true;
						self.isServerVerify = false;

					});
            },

			changePhone: function () {
				var self = this;
                this.isValidateErrors = false;

				var realPhone = this.fixPhone(this.phone);
				if (!this.isValidatePhone(this.phone)) {
					return;
				}
				axios.post('/Profiles/ChangePhoneForNotification', {
					Phone: realPhone
				})
					.then(function (response) {
						console.log(response.data);
						self.serverResponse = response.data;						
					})
					.catch(function (error) {
						console.log(error);
						self.isValidateErrors = true;
						self.serverMessage = ['Изменение номера телефона невозможно, попробуйте позже']
					});
            },

			changeEmail: function () {
				var self = this;
				this.isValidateErrors = false;
				axios.post('/Profiles/ChangeEmailForNotification', {
					Email: self.email.trim()
				})
					.then(function (response) {
						self.serverResponse = response.data;
					})
					.catch(function (error) {
						console.log(error)
						self.isValidateErrors = true;
						self.serverMessage = ['Изменение email невозможно, попробуйте позже']
					});
			},	

			fixPhone: function (phone) {
				if (phone.length > 0) {
                  //  var result = this.phone.replace(/[^+\d]/g, "")
					var result = this.phone.replace("+", "").replace("-", "").replace("-", "").replace("(", "").replace(")", "").replace(" ", "");

                    if (result.length > 0) {
						if (result.length == 10 && result.substring(0, 1) !== "8" && result.substring(0, 1) !== "7") {
                            result = "7" + result;
                        }
					}
				}
                return result;
            },

            isValidatePhone: function (phone) {
                var result = false;
                if (phone.length > 0) {
                    var phoneFixed = this.fixPhone(phone);
                    if (phoneFixed.length == 11) {
                        result = true;
                    }
                }
                return result;
            },



			verifyPhoneStart: function (event) {
				event.stopPropagation();

				if (this.phone == null) {
                    return;
                }

                var realPhone = this.fixPhone(this.phone);
				if (!this.isValidatePhone(this.phone)) {
                    return;
                }

				const self = this;

				console.log("verifyPhoneStart");
				self.phoneVerifyError = '';
				self.isPhoneVerified = 0;
				self.phoneCode = '';
				self.inputCode = "";
				var tvalue = $('input[name="__RequestVerificationToken"]').val();
				let axiosConfig = {
				    headers: { 'RequestVerificationToken': tvalue }
				};
				const data = {
				};
                console.info(self.phone);

				//const showTimer = document.querySelector('.js-timer');
				//$(showTimer).addClass('is-show');
    //            self.counter = self.lifeTimeCode;
				//self.countdown();
    //            const timer = container.find('.js-timer')[0];
				//playTimer(timer);
				//self.checkTimer(poisonCodeAgain, self.verifyPhoneAgain);

				axios.post('/Profiles/SendRequestNotificationPhoneVerify/' + realPhone, data, axiosConfig)
					.then(function (response) {
						if (response.data.isSuccess) {
							console.log("verifyPhoneStart: отправка успешная");

                            self.counter = self.lifeTimeCode;
							self.showHideSendCodeAgainBlock(false, self.curOrderId);
							self.showInputCodeDev(self.curOrderId);
                            self.countdown();

							self.showHideCaptchaBlock(false, self.curOrderId);
							self.showHideSendCodeBlock(false, self.curOrderId);
							self.showHideInputCodeBlock(true, self.curOrderId);
						}
						if (!response.data.isSuccess) {
							self.isValidateErrors = true;
							self.isServerVerify = false;
							self.phoneVerifyError = response.data.message.join('');
                            console.log("verifyPhoneStart: отправка неуспешная");

                            self.counter = self.lifeTimeCode;
							self.showHideSendCodeAgainBlock(false, self.curOrderId);
							self.showInputCodeDev(self.curOrderId);
                            self.countdown();

							self.showHideCaptchaBlock(false, self.curOrderId);
							self.showHideSendCodeBlock(false, self.curOrderId);
							self.showHideInputCodeBlock(true, self.curOrderId);
						}
					})
					.catch(function (error) {
						self.isValidateErrors = true;
						self.isServerVerify = false;
						self.phoneVerifyError = 'Верификация телефона невозможна, попробуйте позже';
						console.log("verifyPhoneStart: Верификация телефона невозможна, попробуйте позже");
					});
			},

			checkTimer(timer, fn) {
				var timerInterval = null;
				timerInterval = setInterval(function () {
					if (timer.css('display') != 'none') {
						fn();
						clearInterval(timerInterval);
					}
				}, 2000);
			},

			countdown: function () {
                var self = this;
				//self.showHideSendCodeAgainBlock(false, self.curOrderId);
				//self.showInputCodeDev(self.curOrderId);
				setTimeout(function () {
                    if (self.counter <= 0) {
						if (self.showInputCodeDiv[self.curOrderId]==true) self.showHideSendCodeAgainBlock(true, self.curOrderId);
						self.hideInputCodeDev(self.curOrderId);
						//self.endLifeRestoreCode();
						//self.numberStep = 2;
						//self.responseSendEmail = "Истекло время кода подтверждения, пожалуйста, попробуйте с начала еще раз"
						//self.responseSendLogin = "Истекло время кода подтверждения, пожалуйста, попробуйте с начала еще раз"
					} else {
						self.counter--;
						self.countdown();
					}

				},
					1000);
            },

	
			verifyEmailStart: function (event) {
				event.stopPropagation();
				if (this.email == '') {
					return;
				}

				const self = this;

				console.log("verifyEmailStart");

				self.emailVerifyError = '';
				self.isEmailVerified = 0;
				self.emailCode = '';
				self.inputCode = "";

			//const showTimer = document.querySelector('.js-timer');
			//$(showTimer).addClass('is-show');
//            self.counter = self.lifeTimeCode;
			//self.countdown();
//            const timer = container.find('.js-timer')[0];
			//playTimer(timer);
			//self.checkTimer(poisonCodeAgain, self.verifyPhoneAgain);

				axios.post('/Profiles/SendRequestNotificationEmailVerify/' + formId + '/' + self.email)
					.then(function (response) {
						if (response.data.isSuccess) {
							console.log("verifyEmailStart: отправка успешная");

                            self.counter = self.lifeTimeCode;
							self.showHideSendCodeAgainBlock(false, self.curOrderId);
							self.showInputCodeDev(self.curOrderId);
                            self.countdown();

                            self.showHideCaptchaBlock(false, self.curOrderId);
							self.showHideSendCodeBlock(false, self.curOrderId);
							self.showHideInputCodeBlock(true, self.curOrderId);
						}
                        if (!response.data.isSuccess) {

                            self.counter = self.lifeTimeCode;
							self.showHideSendCodeAgainBlock(false, self.curOrderId);
							self.showInputCodeDev(self.curOrderId);
                            self.countdown();

							self.showHideCaptchaBlock(false, self.curOrderId);
							self.showHideSendCodeBlock(false, self.curOrderId);
							self.showHideInputCodeBlock(true, self.curOrderId);

							self.isValidateErrors = true;
							self.isServerVerify = false;
							self.emailVerifyError = response.data.message.join('');
							console.log("verifyEmailStart: отправка неуспешная");
						}

					})
					.catch(function (error) {
						self.isValidateErrors = true;
						self.isServerVerify = false;
						self.emailVerifyError = 'Верификация email невозможна, попробуйте позже';
						console.log("verifyEmailStart: Верификация email невозможна, попробуйте позже");

					});

				event.stopPropagation();
			},


			verifyPhoneCode: async function () {
				var self = this;
                this.isValidateErrors = false;
                this.codeVerifyError = "";
                console.log("verifyPhoneCode");

                var realPhone = this.fixPhone(this.phone);
				if (!this.isValidatePhone(this.phone)) {
					return;
				}

				return await axios.post('/Profiles/VerifyCode', {
					Phone: realPhone,
					VerificationCode: self.phoneCode
				})
					.then(function (response) {
						if (response.data.isSuccess) {
							self.phoneVerifyError = '';
							console.log("verifyPhoneCode: верификация успешная");
							self.noErrorCode(self.curOrderId);
							//self.hideCode();
                            self.changePhone();
							//self.showHideCaptchaBlock(false, self.curOrderId);
							//self.showHideSendCodeBlock(false, self.curOrderId);
       //                     self.showHideInputCodeBlock(false, self.curOrderId);
							self.hideInputCodeDev(self.curOrderId);
						}
                        else {
							self.serverMessage = response.data.message[0]
                            self.phoneVerifyError = response.data.message.join();
                            self.codeVerifyError = self.phoneVerifyError;
							self.isValidateErrors = true;
							console.log("verifyPhoneCode: верификация неуспешная");
							self.errorCode(self.curOrderId);
						}
						return response.data.isSuccess;
					})
					.catch(function (error) {
                        self.isValidateErrors = true;
						self.serverMessage = response.data.message[0]
                        self.phoneVerifyError = response.data.message.join();
						self.codeVerifyError = self.phoneVerifyError;
                        console.log("verifyPhoneCode: верификация неуспешная");
						self.errorCode(self.curOrderId);
						return false;
					});
			},
			verifyEmailCode: async function () {
				var self = this;
                this.isValidateErrors = false;
				this.codeVerifyError = "";

				console.log("verifyEmailCode");

				return await axios.post('/Profiles/VerifyCode', {
					Login: formId,
					Email: self.email,
					VerificationCode: self.emailCode
				})
					.then(function (response) {
						if (response.data.isSuccess) {
							self.emailVerifyError = '';
							console.log("verifyEmailCode: верификация успешная");
							self.noErrorCode(self.curOrderId);
                            //self.hideCode();
                            self.changeEmail();
							//self.showHideCaptchaBlock(false, self.curOrderId);
							//self.showHideSendCodeBlock(false, self.curOrderId);
       //                     self.showHideInputCodeBlock(false, self.curOrderId);
                            self.hideInputCodeDev(self.curOrderId);
							
						}
                        else {
							self.serverMessage = response.data.message[0]
							self.emailVerifyError = response.data.message.join();
                            self.isValidateErrors = true;
							self.codeVerifyError = self.emailVerifyError;
							console.log("verifyEmailCode: верификация неуспешная");
							self.errorCode(self.curOrderId);
						}
						return response.data.isSuccess;
					})
					.catch(function (error) {
						self.serverMessage = response.data.message[0]
						self.emailVerifyError = response.data.message.join();
						self.isValidateErrors = true;
                        self.codeVerifyError = self.emailVerifyError;
                        console.log("verifyEmailCode: верификация неуспешная");
						self.errorCode(self.curOrderId);
						return false;
					});
            },

			verifyCheckCode: async function (event) {
				if (this.curNotifyType == 0 || this.curNotifyType == 2) {//телефон
					this.phoneCode = this.inputCode;
					//this.showCode();
					await this.verifyPhoneCheckCode(event);
				}
				if (this.curNotifyType == 1) {//емэйл
					this.emailCode = this.inputCode;
					//this.showCode();
					await this.verifyEmailCheckCode(event);
				}
            },

			verifyEmailCheckCode: async function (event) {

				event.stopPropagation();
				this.isEmailVerified = 0;

				if (this.emailCode == '') {
					return;
				}

				if (await this.verifyEmailCode()) {
					this.isEmailVerified = 1;
	
					if (this.curNotifyType == 0) {//пуш
						this.showHidePushBlock(true, this.curOrderId);
					}
					if (this.curNotifyType == 1) {//емэйл
						this.showHideEmailBlock(true, this.curOrderId);
					}
					if (this.curNotifyType == 2) {//телефон
						this.showHidePhoneBlock(true, this.curOrderId);
					}
				}
				else {
					this.isEmailVerified = -1;
				}
			},

  			verifyPhoneCheckCode: async function (event) {

				event.stopPropagation();
				this.isPhoneVerified = 0;

				if (this.phoneCode == '') {
					return;
				}

				var v = await this.verifyPhoneCode();

				if (v) {
                    this.isPhoneVerified = 1;

                    if (this.curNotifyType == 0) {//пуш
						this.showHidePushBlock(true, this.curOrderId);
					}
					if (this.curNotifyType == 1) {//емэйл
						this.showHideEmailBlock(true, this.curOrderId);
					}
					if (this.curNotifyType == 2) {//телефон
						this.showHidePhoneBlock(true, this.curOrderId);
					}

				}
				else {
					this.isPhoneVerified = -1;

				}

			},


            activeSubscr: function (code, notifyType, orderId) {
                this.curOrderId = orderId;
                var result = this.updateSubscription(notifyType, code, true);
            },

            actualSubscr: function (notifyType, orderId, active) {
                console.log('actualSubscr: notifyType = ' + notifyType);
				console.log('actualSubscr: orderId = ' + orderId);
				console.log('actualSubscr: active = ' + active);

				if (notifyType == 0) {
					this.subscrPushActive[orderId] = active;
				}
				if (notifyType == 1) {
					this.subscrEmailActive[orderId] = active;
				}
				if (notifyType == 2) {
					this.subscrSmsActive[orderId] = active;
                }
                this.subscrActive[orderId] = this.subscrPushActive[orderId] || this.subscrEmailActive[orderId] || this.subscrSmsActive[orderId];
                this.$forceUpdate();
				console.log('actualSubscr: subscrSmsActive[orderId] = ' + this.subscrSmsActive[orderId]);
				console.log('actualSubscr: this.subscrEmailActive[orderId] = ' + this.subscrEmailActive[orderId]);
                console.log('actualSubscr: subscrPushActive[orderId] = ' + this.subscrPushActive[orderId]);
				console.log('actualSubscr: subscrActive[orderId] = ' + this.subscrActive[orderId]);

            },

            deActiveSubscr: function (code, notifyType, orderId) {
				this.curOrderId = orderId;
				var result =  this.updateSubscription(notifyType, code, false);
			},

            hideShowConfirmButtons: function (action, orderId, notifyType) {
                var id = notifyType + 'confirm_' + orderId;
                var elem = document.getElementById(id);
                if (elem != undefined) {
                    if (action == "hide") $(elem).addClass('is-hidden');
					if (action == "show") $(elem).removeClass('is-hidden');
                }
            },

			hideShowToActiveButtons: function (action, orderId, notifyType) {
				var id = notifyType + 'toactive_' + orderId;
				var elem = document.getElementById(id);
				if (elem != undefined) {
					if (action == "hide") $(elem).addClass('is-hidden');
					if (action == "show") $(elem).removeClass('is-hidden');
				}
            },

			hideShowActiveButtons: function (action, orderId, notifyType) {
				var id = notifyType + 'active_' + orderId;
				var elem = document.getElementById(id);
				if (elem != undefined) {
					if (action == "hide") $(elem).addClass('is-hidden');
					if (action == "show") $(elem).removeClass('is-hidden');
				}
			},



            changeNotifyType: function (orderId) {
                var selectType = document.getElementById('notifytype_' + orderId);
                var selectId = '#notifytype_' + orderId;
				this.notifyTypeSelected[orderId] = $(selectId).val();
                var selectedName = $(selectId + ' option:selected').text();

                this.curNotifyType = this.notifyTypeSelected[orderId];
				if (this.curNotifyType == 0) {//пуш
					this.showHidePushBlock(true, orderId);
				}
				if (this.curNotifyType == 1) {//емэйл
					this.showHideEmailBlock(true, orderId);
				}
				if (this.curNotifyType == 2) {//телефон
					this.showHidePhoneBlock(true, orderId);
                }

				this.showHideCaptchaBlock(false, orderId);
				this.showHideSendCodeBlock(false, orderId);
                this.showHideInputCodeBlock(false, orderId);
                this.showHideSendCodeAgainBlock(false, orderId);
				this.inputCapchaCode = "";
				this.checkCapchaCode = false;
                this.capchaError = "";
                this.codeVerifyError = "";
                if (this.isPhoneVerified == -1) this.isPhoneVerified = 0;
                if (this.isEmailVerified == -1) this.isEmailVerified = 0              
               
				this.$forceUpdate();
            },

   //         checkPhone: function (phone) {
   //         },

			//checkEmail: function (email) {
   //         },

			emailType: function (value) {
				return value.match('\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*') ? true : false;
			},
          
            loadData: function () {
                console.log(JSON.parse(this.notifications));
                this.notificationObj = JSON.parse(this.notifications);
                console.log(this.notificationObj);
                console.log(this.notificationObj.NotificationList);
                console.log(this.notificationObj.PhoneNumber);

                this.handleData();

                //console.log(this.notifications);
				//console.log(this.notifications.notificationlist);
    //            console.log(this.notifications.Notificationlist);
    //            console.log(this.notifications.phoneNumber);
				//console.log(this.notifications.PhoneNumber);

            },

            handleData: function () {
                for (var i = 0; i < this.notificationObj.NotificationList.length; i++) { 
					this.subscrCode[i + 1] = this.notificationObj.NotificationList[i].Code;
                    this.subscrActive[i + 1] = this.notificationObj.NotificationList[i].Active;
                    //this.switchChecked[i+1]="";
                    if (this.subscrActive[i + 1]==true) 
                    {
                       // this.switchChecked[i+1]="checked";
                       // this.switchHandle(this.subscrActive[i + 1], i+1);
                    }
					this.subscrSmsActive[i + 1] = this.notificationObj.NotificationList[i].SmsActive;
					this.subscrEmailActive[i + 1] = this.notificationObj.NotificationList[i].EmailActive;
                    this.subscrPushActive[i + 1] = this.notificationObj.NotificationList[i].PushActive;
                    this.notifyTypeSelected[i + 1] = 0;
                    this.showCapchaDiv[i + 1] = false;
					this.showSendCodeDiv[i + 1] = false;
                    this.showInputCodeDiv[i + 1] = false;
                    this.showSendAgain[i + 1] = false;
                    this.showPhoneDiv[i + 1] = true;
					this.showEmailDiv[i + 1] = true;
					this.showPushDiv[i + 1] = true;
                    this.changeNotifyType(i + 1);
                }
				this.phone = this.notificationObj.PhoneNumber;
				this.email = this.notificationObj.Email;
				this.phoneConfirmed = this.notificationObj.PhoneNumberConfirmed;
                this.emailConfirmed = this.notificationObj.EmailConfirmed;
                console.log(this.subscrCode);
				console.log(this.subscrActive);
                console.log(this.switchChecked);
				console.log(this.subscrSmsActive);
				console.log(this.subscrEmailActive);
				console.log(this.subscrPushActive);
				console.log(this.phone);
				console.log(this.email);
				console.log(this.phoneConfirmed);
				console.log(this.emailConfirmed);
            },

            switchHandle : function(active, orderId) {
                var elem = document.getElementById('datacard_' + orderId);
				var checkbox = document.getElementById('checkbox_' + orderId);

                if (elem != undefined && checkbox != undefined) {
					if (active == true) {
						$(elem).addClass('in');
                        checkbox.checked = true;	
						//$(elem).addClass("is-open");
					}
					else {
                        $(elem).removeClass('in');
						checkbox.checked = false;
						//$(elem).removeClass("is-open");
					}
				}   
           },

           initSwithes: function () {
			   for (var i = 0; i < this.notificationObj.NotificationList.length; i++) {
				   if (this.notificationObj.NotificationList[i].Active == true) {
					   this.switchHandle(this.notificationObj.NotificationList[i].Active, i + 1);
				   }
			   }       
           },

			updateSubscription:  function (notificationType, code, active) {
				var self = this

				 axios.post('/Profiles/UpdateSubscription', {
					NotificationType: notificationType,
					Code: code,
					Active: active,
					TimeBegin: '00:00:00',
					TimeEnd: '23:59:59'
				})
					.then(function (response) {

                        if (response.status==200) {
                            self.actualSubscr(notificationType, self.curOrderId, active);
                            return true;
                        }
                        else { return false; }
					})
                    .catch(function (error) {
                        return false;
					})
					.finally(function () {
					});
			},
  
        },
        mounted() {
            this.initSwithes();
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// Scripts/app/profiles/components/NotificationSettings.vue